(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(44265);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93021);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16423);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: initial;\n  border: none;\n  text-decoration: none;\n  &:focus {\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const Link = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_1___default()))(_templateObject(), (param)=>{
    let { theme , $origin , $textSecondary , $error , $nowrap , $color , href  } = param;
    return "\n    color: ".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)([
        [
            (props)=>props.$error,
            ()=>theme.palette.error.main
        ],
        [
            (props)=>props.$origin,
            ()=>theme.palette.text.primary
        ],
        [
            (props)=>props.$textSecondary,
            ()=>theme.palette.text.secondary
        ],
        [
            (props)=>!!props.$color,
            ()=>(0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(theme.palette, $color)
        ],
        [
            ()=>true,
            ()=>theme.palette.primary.main
        ]
    ])({
        $origin,
        $textSecondary,
        $error,
        $color
    }), ";\n    white-space: ").concat($nowrap ? "nowrap" : "normal", ";\n    cursor: ").concat(href !== "" ? "pointer" : "default", ";\n\n    &:hover {\n      color: ").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)([
        [
            (props)=>props.$error,
            ()=>theme.palette.error.main
        ],
        [
            (props)=>props.$origin,
            ()=>theme.palette.text.primary
        ],
        [
            (props)=>props.$textSecondary,
            ()=>theme.palette.text.secondary
        ],
        [
            (props)=>!!props.$color,
            ()=>(0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(theme.palette, $color)
        ],
        [
            ()=>true,
            ()=>theme.palette.primary.main
        ]
    ])({
        $origin,
        $textSecondary,
        $error,
        $color
    }), ";\n    }\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 76457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N3": function() { return /* binding */ ServiceClassificationWrapper; },
/* harmony export */   "Ud": function() { return /* binding */ BookingServiceModalWrapper; },
/* harmony export */   "W4": function() { return /* binding */ ButtonWrapper; },
/* harmony export */   "__": function() { return /* binding */ ScrollableWrapper; },
/* harmony export */   "gr": function() { return /* binding */ LogoImageWrapper; },
/* harmony export */   "iW": function() { return /* binding */ StickyWrapper; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "uf": function() { return /* binding */ BookingServiceClassificationWrapper; },
/* harmony export */   "xt": function() { return /* binding */ ServiceIconWrapper; }
/* harmony export */ });
/* unused harmony exports HoverCardPoint, IconButtonWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80562);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: calc(100% - 100px);\n  max-height: calc(100% - 100px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: sticky;\n  top: 0;\n  z-index: 8;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: inline-block;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding: 20px;\n  width: 100%;\n  background-color: white;\n  display: flex;\n  justify-content: end;\n  border-radius: 10px;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}



const Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , $autoHeight  } = param;
    return "\n    background-color: ".concat(theme.palette.background.gray, ";\n    width: 100%;\n    height: 100%;\n    padding: 16px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    ").concat(theme.breakpoints.up("md"), " {\n      padding: 20px;\n    }\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      width: 724px;\n      height: ").concat($autoHeight ? "auto" : "620px", ";\n      border-radius: 10px;\n    }\n  ");
});
const ScrollableWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject1());
const StickyWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject2());
const ServiceClassificationWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject3(), (param)=>{
    let { theme , $isFirst  } = param;
    return "\n    background-color: ".concat(theme.palette.background.default, ";;\n    border-radius: 12px;\n    height: auto;\n    width: 100%;\n    padding: 16px;\n    margin-top: ").concat($isFirst ? "0px" : "16px", ";\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      padding: 20px;\n    }\n  ");
});
const ServiceIconWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject4());
const LogoImageWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject5(), (param)=>{
    let { $hovered  } = param;
    return "\n    position: relative;\n    margin-bottom: 8px;\n\n    transform: ".concat($hovered ? "translate(0, -8px)" : "translate(0, 0)", ";\n    transition: all 0.2s ease-in-out;\n  ");
});
const HoverCardPoint = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject6(), (param)=>{
    let { theme , $hovered  } = param;
    return "\n    height: 4px;\n    width: 4px;\n    border-radius: 50%;\n    background-color: ".concat($hovered ? theme.palette.primary.main : "transparent", ";\n    position: absolute;\n    left: 50%;\n    bottom: -8px;\n    transform: translate(-50%, 0);\n  ");
});
const IconButtonWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject7(), (param)=>{
    let { theme  } = param;
    return "\n  > .MuiSvgIcon-root {\n    fill: ".concat(theme.palette.text.minus2, ";\n    font-size: 24px;\n  }\n");
});
const ButtonWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject8());
const BookingServiceModalWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Wrapper)(_templateObject9(), (param)=>{
    let { theme  } = param;
    return "\n    background-color: ".concat(theme.palette.background.default, ";\n  ");
});
const BookingServiceClassificationWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ServiceClassificationWrapper)(_templateObject10(), (param)=>{
    let { theme  } = param;
    return "\n    background-color:  ".concat(theme.palette.background.gray, ";;\n  ");
});


/***/ }),

/***/ 71273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OK": function() { return /* binding */ Tab; },
/* harmony export */   "mQ": function() { return /* binding */ Tabs; },
/* harmony export */   "tS": function() { return /* binding */ TabsWrapper; }
/* harmony export */ });
/* unused harmony export StyledTab */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var components_common_Tabs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50557);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: transparent;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}




const StyledTabs = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(components_common_Tabs__WEBPACK_IMPORTED_MODULE_2__/* .Tabs */ .m)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    & .MuiTabs-indicatorSpan {\n      position: absolute,\n      max-width: 32px;\n      width: 32px !important;\n      border-radius: 2px;\n      background: ".concat(theme.palette.primary.main, ";\n    }\n  ");
});
const TabsWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject1());
const Tabs = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTabs, {
        ...props,
        variant: "scrollable",
        scrollButtons: "auto",
        textColor: "primary",
        TabIndicatorProps: {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "MuiTabs-indicatorSpan"
            }),
            sx: {
                display: "flex",
                justifyContent: "center",
                background: "transparent"
            }
        }
    });
};
const StyledTab = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(components_common_Tabs__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .O)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    &.MuiTab-root {\n      width: 64px;\n      font-size: ".concat(theme.typography.label.fontSize, ";\n      font-weight: 700;\n      padding: ").concat(theme.spacing(0), ";\n      white-space: nowrap;\n\n      &:not(:first-child) {\n        margin-left: 16px;\n      }\n    }\n  ");
});
const Tab = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTab, {
        ...props,
        disableTouchRipple: true
    });
};


/***/ }),

/***/ 11666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_common_ContentWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55856);
/* harmony import */ var config_theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26059);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}





const StyledBannerWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(components_common_ContentWrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , $isHomePage  } = param;
    return "\n    width: 100%;\n    overflow: hidden;\n    max-width: ".concat(config_theme__WEBPACK_IMPORTED_MODULE_5__/* .maxContentWidth */ .xN, ";\n    min-height: 180px;\n    height: auto;\n    padding: 0;\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      min-height: 325px;\n      padding: 0 32px;\n    }\n\n    ").concat(theme.breakpoints.up("xl"), " {\n      min-height: 360px;\n      padding: 0 48px;\n    }\n\n    ").concat(theme.breakpoints.up("xxl"), " {\n      min-height: 460px;\n      padding: 0 64px;\n    }\n\n    ").concat($isHomePage && "\n      max-width: ".concat(config_theme__WEBPACK_IMPORTED_MODULE_5__/* .indexPageMaxContentWidth */ .LN, ";\n      padding-left: ").concat(theme.spacing(4), ";\n      padding-right: ").concat(theme.spacing(4), ";\n\n      ").concat(theme.breakpoints.up("md"), " {\n        padding-left: ").concat(theme.spacing(8), ";\n        padding-right: ").concat(theme.spacing(8), ";\n      }\n\n      ").concat(theme.breakpoints.up("xl"), " {\n        padding-left: ").concat(theme.spacing(12), ";\n        padding-right: ").concat(theme.spacing(12), ";\n      }\n    "), "\n  ");
});
const BannerWrapper = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const isHomePage = router.pathname === "/";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBannerWrapper, {
        ...props,
        $isHomePage: isHomePage
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BannerWrapper);


/***/ }),

/***/ 44395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}





const Border = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    background-color: ".concat(theme.palette.background.disabled, ";\n    height: 2px;\n    position: relative;\n  ");
});
const SelectedBar = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject1(), (param)=>{
    let { theme , $start  } = param;
    return "\n    background-color: ".concat(theme.palette.text.minus2, ";\n    height: 2px;\n    left: 0;\n    width: ").concat($start ? "100%" : "0", ";\n    position: absolute;\n    transition: width 5s ease-out;\n  ");
});
const SelectedAnimation = ()=>{
    const [start, setStart] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setTimeout(()=>setStart(true));
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SelectedBar, {
        $start: start
    });
};
const DesktopPaginationWithTitle = (param)=>{
    let { data , currentIndex , onPaginationIndexClick  } = param;
    var _data_map;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        display: "flex",
        justifyContent: "center",
        mt: {
            md: 10
        },
        children: data === null || data === void 0 ? void 0 : (_data_map = data.map) === null || _data_map === void 0 ? void 0 : _data_map.call(data, (banner, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                onClick: ()=>onPaginationIndexClick(index),
                sx: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    width: "152px",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Border, {
                            children: currentIndex === index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SelectedAnimation, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "body1",
                            color: currentIndex === index ? "text.minus2" : "background.disabled",
                            fontWeight: "fontWeightBold",
                            py: 4,
                            px: 3,
                            textAlign: "center",
                            children: banner.title || banner.name
                        })
                    ]
                })
            }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DesktopPaginationWithTitle);


/***/ }),

/***/ 20667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  word-wrap: break-word;\n  word-break: break-all;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const BreakWordTypography = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (BreakWordTypography);


/***/ }),

/***/ 18450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D2": function() { return /* binding */ HideInDesktopGrid; },
/* harmony export */   "W": function() { return /* binding */ HideInMobileGrid; },
/* harmony export */   "aI": function() { return /* binding */ HideInDesktopBox; },
/* harmony export */   "dz": function() { return /* binding */ HideInMobileBox; }
/* harmony export */ });
/* unused harmony exports withHideInMobile, withHideInDesktop */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79072);



const withHideInMobile = (WrappedComponent)=>{
    return (param)=>{
        let { display ="block" , sx ={} , component , ...props } = param;
        const finalDisplay = props.display === "flex" ? "flex" : component === "span" ? "inline-block" : display;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
            sx: {
                display: {
                    xs: "none",
                    lg: finalDisplay
                },
                ...sx
            },
            ...props
        });
    };
};
const withHideInDesktop = (WrappedComponent)=>{
    return (param)=>{
        let { display ="block" , sx ={} , component , ...props } = param;
        const finalDisplay = props.display === "flex" ? "flex" : component === "span" ? "inline-block" : display;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
            sx: {
                display: {
                    xs: finalDisplay,
                    lg: "none"
                },
                ...sx
            },
            ...props
        });
    };
};
const HideInMobileBox = withHideInMobile(_mui_material_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
const HideInDesktopBox = withHideInDesktop(_mui_material_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
const HideInMobileGrid = withHideInMobile(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);
const HideInDesktopGrid = withHideInDesktop(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);


/***/ }),

/***/ 37524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N1": function() { return /* binding */ ScrollableBox; },
/* harmony export */   "OW": function() { return /* binding */ FullscreenModal; },
/* harmony export */   "nv": function() { return /* binding */ InfoModal; },
/* harmony export */   "rK": function() { return /* binding */ FunctionModal; },
/* harmony export */   "tn": function() { return /* binding */ UserDataModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39477);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Slide__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25425);
/* harmony import */ var _mui_material_Fade__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9942);
/* harmony import */ var _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58735);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  overflow-y: auto;\n  scrollbar-width: none;\n  border: none;\n  outline: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  @media screen and (min-width: 992px) {\n    width: 540px;\n    height: initial;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}







const functionModalBackdropProps = {
    timeout: 500
};
const Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , $autoHeight  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n\n    @media screen and (min-width: 992px) {\n      margin-top: 20px;\n      width: 540px;\n      height: ").concat($autoHeight ? "auto" : "737px", ";\n      border-radius: 10px;\n    }\n  ");
});
const ScrollableBox = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject1());
// fullscreen in mobile devices
const FunctionModal = (param)=>{
    let { open , onClose , children , autoHeight , ModalWrapper , ...rest } = param;
    const UsedWrapper = ModalWrapper || Wrapper;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Slide__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            direction: "up",
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UsedWrapper, {
                    onClick: (e)=>e.stopPropagation(),
                    $autoHeight: autoHeight,
                    children: children
                })
            })
        })
    });
};
const Fullscreen = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2(), (param)=>{
    let { theme , $autoHeight  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 100%;\n    height: ").concat($autoHeight ? "auto" : "100%", ";\n    min-height: ").concat($autoHeight ? "100vh" : "auto", ";\n    margin: 0 auto;\n  ");
});
// fullscreen in any devices
const FullscreenModal = (param)=>{
    let { open , onClose , children , autoHeight , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Slide__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            direction: "up",
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Fullscreen, {
                    onClick: (e)=>e.stopPropagation(),
                    $autoHeight: autoHeight,
                    children: children
                })
            })
        })
    });
};
const InfoWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: calc(100% - 60px);\n    max-width: 540px;\n    height: initial;\n    margin: 0 auto;\n    border-radius: 10px;\n  ");
});
const UserDataWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject4(), (param)=>{
    let { theme  } = param;
    return "\n    overflow: hidden;\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 354px;\n    height: initial;\n    margin: 0 auto;\n    font-size: 16px;\n    border-radius: 12px;\n    border: 1px solid ").concat(theme.palette.grey.secondary, ";\n    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.1);\n  ");
});
// regular modal even in mobile devices
const InfoModal = (param)=>{
    let { open , onClose , children , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Fade__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    pt: "150px",
                    pb: "40px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InfoWrapper, {
                        onClick: (e)=>e.stopPropagation(),
                        children: children
                    })
                })
            })
        })
    });
};
// user data modal
const UserDataModal = (param)=>{
    let { open , onClose , children , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Fade__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    pt: "150px",
                    pb: "40px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UserDataWrapper, {
                        onClick: (e)=>e.stopPropagation(),
                        children: children
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 84070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73221);



const NoindexRemoval = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
            children: config_constants__WEBPACK_IMPORTED_MODULE_2__/* .APP_ENV */ .Wi === "prod" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {}, "noindex")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoindexRemoval);


/***/ }),

/***/ 2925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  ",
        ";\n  line-height: ",
        ";\n  height: ",
        ";\n  text-align: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const NowrapDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { $lines  } = param;
    return !!$lines && $lines > 1 ? "display: -webkit-box;" + "-webkit-line-clamp: ".concat($lines, ";") + "-webkit-box-orient: vertical;" : "white-space: nowrap;";
}, (param)=>{
    let { $fixHeight  } = param;
    return $fixHeight ? "1.2em" : "";
}, (param)=>{
    let { $lines , $fixHeight  } = param;
    return $fixHeight ? ($lines || 1) * 1.2 + "em" : "auto";
}, (param)=>{
    let { $textCenter  } = param;
    return $textCenter ? "center" : "left";
});
/* harmony default export */ __webpack_exports__["Z"] = (NowrapDiv);


/***/ }),

/***/ 99469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1216);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61953);




const moduleMap = {
    graphicFix: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(9072), __webpack_require__.e(5616), __webpack_require__.e(5795), __webpack_require__.e(1427)]).then(__webpack_require__.bind(__webpack_require__, 45941)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(45941)
                    ]
            },
            ssr: false
        }),
        minHeight: 250
    },
    graphicMore: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(5616), __webpack_require__.e(6760), __webpack_require__.e(4700)]).then(__webpack_require__.bind(__webpack_require__, 25975)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(25975)
                    ]
            },
            ssr: false
        }),
        minHeight: 250
    },
    publicitySmall: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(5616), __webpack_require__.e(8757)]).then(__webpack_require__.bind(__webpack_require__, 8757)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(8757)
                    ]
            },
            ssr: false
        }),
        minHeight: 385
    },
    publicityLarge: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(5616), __webpack_require__.e(8902)]).then(__webpack_require__.bind(__webpack_require__, 88902)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(88902)
                    ]
            },
            ssr: false
        }),
        minHeight: 500
    },
    banner: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(6760), __webpack_require__.e(8121), __webpack_require__.e(9260)]).then(__webpack_require__.bind(__webpack_require__, 24200)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(24200)
                    ]
            },
            ssr: false
        }),
        minHeight: 190
    },
    bannerLarge: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 1040).then(__webpack_require__.bind(__webpack_require__, 61040)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(61040)
                    ]
            },
            ssr: false
        }),
        minHeight: 100
    },
    articleMainImage: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(9072), __webpack_require__.e(5616), __webpack_require__.e(5795), __webpack_require__.e(4891)]).then(__webpack_require__.bind(__webpack_require__, 28303)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(28303)
                    ]
            },
            ssr: false
        }),
        minHeight: 400
    },
    articleSmallImage: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(9072), __webpack_require__.e(5616), __webpack_require__.e(5795), __webpack_require__.e(5084)]).then(__webpack_require__.bind(__webpack_require__, 92952)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(92952)
                    ]
            },
            ssr: false
        }),
        minHeight: 170
    },
    customHtml: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 643).then(__webpack_require__.bind(__webpack_require__, 20643)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(20643)
                    ]
            },
            ssr: true
        }),
        minHeight: 1
    },
    graphicN: {
        component: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(5795), __webpack_require__.e(2175)]).then(__webpack_require__.bind(__webpack_require__, 59997)), {
            loadableGenerated: {
                webpack: ()=>[
                        /*require.resolve*/(59997)
                    ]
            },
            ssr: false
        }),
        minHeight: 250
    }
};
const Present = (param)=>{
    let { data , lazy , lazyOptions , isServicePage =false  } = param;
    if (!moduleMap[data === null || data === void 0 ? void 0 : data.type]) {
        return null;
    }
    const { component: DynamicModule , minHeight  } = moduleMap[data === null || data === void 0 ? void 0 : data.type];
    const minHeightValue = typeof minHeight === "function" ? minHeight(data) : minHeight;
    if (lazy) {
        var _lazyOptions_offset;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            height: minHeightValue,
            offset: (_lazyOptions_offset = lazyOptions === null || lazyOptions === void 0 ? void 0 : lazyOptions.offset) !== null && _lazyOptions_offset !== void 0 ? _lazyOptions_offset : 0,
            scrollContainer: (lazyOptions === null || lazyOptions === void 0 ? void 0 : lazyOptions.containerId) && "#".concat(lazyOptions.containerId),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                minHeight: minHeightValue,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicModule, {
                    data: data,
                    isServicePage: isServicePage
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        minHeight: minHeightValue,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicModule, {
            data: data,
            isServicePage: isServicePage
        })
    });
};
Present.defaultProps = {
    lazy: false,
    lazyOptions: {
        offset: 0,
        containerId: ""
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (Present);


/***/ }),

/***/ 54996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98700);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const ResponsiveDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject(), _mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveDiv);


/***/ }),

/***/ 69854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const ArrowRight = (param)=>{
    let { color , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        $color: color,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "arrow_right_24l",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                d: "M8.293 5.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L13.586 12 8.293 6.707a1 1 0 010-1.414z",
                className: "Vector (Stroke)",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 2982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ ClearSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const ClearSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.0026 14.6654C11.6845 14.6654 14.6693 11.6806 14.6693 7.9987C14.6693 4.3168 11.6845 1.33203 8.0026 1.33203C4.32071 1.33203 1.33594 4.3168 1.33594 7.9987C1.33594 11.6806 4.32071 14.6654 8.0026 14.6654Z",
                fill: "#BDBDBD",
                ...props
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M10.7071 6.70711C11.0976 6.31658 11.0976 5.68342 10.7071 5.29289C10.3166 4.90237 9.68342 4.90237 9.29289 5.29289L8 6.58579L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L6.58579 8L5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071C5.68342 11.0976 6.31658 11.0976 6.70711 10.7071L8 9.41421L9.29289 10.7071C9.68342 11.0976 10.3166 11.0976 10.7071 10.7071C11.0976 10.3166 11.0976 9.68342 10.7071 9.29289L9.41421 8L10.7071 6.70711Z",
                fill: "white"
            })
        ]
    });
};


/***/ }),

/***/ 47624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ FacebookIconSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const FacebookIconSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            className: "ic_share_facebook",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "20",
                    cy: "20",
                    r: "20",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20c0 9.982 7.314 18.257 16.875 19.757V25.781h-5.078V20h5.078v-4.406c0-5.013 2.986-7.781 7.554-7.781 2.189 0 4.477.39 4.477.39v4.922h-2.522c-2.484 0-3.259 1.542-3.259 3.123V20h5.547l-.887 5.781h-4.66v13.976C32.686 38.257 40 29.983 40 20Z",
                    className: "Vector"
                })
            ]
        })
    });
};


/***/ }),

/***/ 52915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ LineCircleSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const LineCircleSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "Logo_Line",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                className: "LINE_LOGO",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    className: "Group",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#4CC764",
                            d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
                            className: "Vector"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            className: "Group",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fill: "#fff",
                                    d: "M20.003 11.301c0-3.585-3.595-6.501-8.011-6.501-4.417 0-8.011 2.917-8.011 6.501 0 3.214 2.85 5.905 6.7 6.414.26.056.616.172.706.395.08.203.052.52.026.725l-.114.685c-.035.203-.162.792.694.432.854-.36 4.613-2.716 6.293-4.65 1.162-1.274 1.718-2.566 1.718-4l-.002-.001Z",
                                    className: "Vector"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                    className: "Group",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "#4CC764",
                                        d: "M17.338 13.371a.153.153 0 0 0 .153-.153v-.568a.154.154 0 0 0-.153-.153h-1.53v-.59h1.53a.153.153 0 0 0 .153-.154v-.567a.154.154 0 0 0-.153-.153h-1.53v-.59h1.53a.153.153 0 0 0 .153-.154v-.567a.154.154 0 0 0-.153-.153h-2.251a.153.153 0 0 0-.153.153v3.496c0 .085.068.153.153.153h2.25Zm-8.325 0a.153.153 0 0 0 .153-.153v-.568a.154.154 0 0 0-.153-.153h-1.53V9.722a.154.154 0 0 0-.152-.153h-.569a.153.153 0 0 0-.153.153v3.496c0 .085.068.153.153.153h2.25Zm1.354-3.802H9.8a.153.153 0 0 0-.153.153v3.495c0 .085.069.153.153.153h.568a.153.153 0 0 0 .153-.153V9.722a.153.153 0 0 0-.153-.153Zm3.868 0h-.569a.153.153 0 0 0-.152.153v2.076l-1.6-2.16-.012-.015H11.9a.03.03 0 0 0-.009-.01l-.003-.003-.008-.007c-.002 0-.003-.002-.005-.003l-.008-.005c-.002 0-.003-.002-.005-.003l-.008-.005-.004-.002-.01-.004-.005-.001-.008-.003c-.002 0-.004 0-.006-.002l-.009-.002h-.007l-.008-.001h-.578a.153.153 0 0 0-.153.153v3.496c0 .085.068.153.153.153h.569a.153.153 0 0 0 .152-.153v-2.076l1.602 2.163a.147.147 0 0 0 .04.038l.001.002.01.006.004.002.008.004.007.003.005.001a.057.057 0 0 0 .01.003h.002a.144.144 0 0 0 .04.006h.565a.153.153 0 0 0 .153-.153V9.724a.153.153 0 0 0-.153-.153v-.002Z",
                                        className: "Vector"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 54806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93021);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16423);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46338);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const SVG = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].svg */ .Z.svg(_templateObject(), (param)=>{
    let { theme , primary , error , white , textSecondary , $ptr , $color  } = param;
    return "\n    fill: ".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)([
        [
            (props)=>props.error,
            ()=>theme.palette.error.main
        ],
        [
            (props)=>props.primary,
            ()=>theme.palette.primary.main
        ],
        [
            (props)=>props.white,
            ()=>theme.palette.primary.contrastText
        ],
        [
            (props)=>props.textSecondary,
            ()=>theme.palette.text.secondary
        ],
        [
            (props)=>!!props.$color,
            ()=>(0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(theme.palette, $color)
        ],
        [
            lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
            ()=>theme.palette.text.primary
        ]
    ])({
        primary,
        error,
        white,
        textSecondary,
        $color
    }), ";\n    ").concat($ptr ? "cursor: pointer;" : "", "\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (SVG);


/***/ }),

/***/ 66212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ SearchSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const SearchSVG = (param)=>{
    let { color , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "search",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4 11a7 7 0 1112.041 4.857 1.005 1.005 0 00-.184.184A7 7 0 014 11zm12.618 7.032a9 9 0 111.414-1.414l3.675 3.675a1 1 0 11-1.414 1.414l-3.675-3.675z",
                className: "Union",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 98780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var _mui_icons_material_ExpandLess__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60181);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}





const ScrollButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    position: fixed;\n    bottom: 100px;\n    right: 20px;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    box-shadow: 0 1px 6px 0 rgb(0 0 0 / 6%), 0 2px 32px 0 rgb(0 0 0 / 16%);\n    background-color: ".concat(theme.palette.grey.third, ";\n    border: 1px solid ").concat(theme.palette.grey.secondary, ";\n    cursor: pointer;\n    color: ").concat(theme.palette.text.primary, ";\n    z-index: 98;\n\n    &:active {\n      background-color: ").concat(theme.palette.primary.bgPlus1, ";\n      border: 1px solid #ffffff;\n    }\n\n    > .muiIcon {\n      position: absolute;\n      top: 50%; \n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n  ");
});
const ScrollToTopButton = (param)=>{
    let { showButton , scrollableRef , isAutoScroll  } = param;
    const onScrollToTopClick = ()=>{
        setTimeout(()=>{
            var _scrollableRef_current;
            return scrollableRef.current && ((_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.scrollTo({
                top: 0,
                behavior: "smooth"
            }));
        }, 0);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (isAutoScroll) {
            setTimeout(()=>{
                var _scrollableRef_current;
                return scrollableRef.current && ((_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.scrollTo({
                    top: 0,
                    behavior: "smooth"
                }));
            }, 0);
        }
    }, [
        isAutoScroll
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButton, {
        style: {
            display: showButton ? "inline" : "none"
        },
        onClick: onScrollToTopClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_ExpandLess__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            fontSize: "large",
            className: "muiIcon"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollToTopButton);


/***/ }),

/***/ 28086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61953);
/* harmony import */ var utils_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13946);
/* harmony import */ var components_common_ResponsiveDiv__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54996);
/* harmony import */ var components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98780);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-y: auto;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n  height: 100%;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}






const Scrollable = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
const ScrollableResponsiveDiv = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(components_common_ResponsiveDiv__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject1());
const ScrollableWrapper = (param)=>{
    let { children , responsive =false , onCopy =null , containerId =null , wrapperRef , isAutoScroll =false  } = param;
    const { showButton , showScrollButton  } = (0,utils_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useShowScrollToTopButton */ .zi)();
    return responsive ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ScrollableResponsiveDiv, {
        onCopy: onCopy,
        ref: wrapperRef,
        onScroll: showScrollButton,
        id: containerId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                showButton: showButton,
                scrollableRef: wrapperRef,
                isAutoScroll: isAutoScroll
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Scrollable, {
        onCopy: onCopy,
        ref: wrapperRef,
        onScroll: showScrollButton,
        id: containerId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                showButton: showButton,
                scrollableRef: wrapperRef,
                isAutoScroll: isAutoScroll
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollableWrapper);


/***/ }),

/***/ 50557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Tab; },
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material_Tabs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62722);
/* harmony import */ var _mui_material_Tab__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18661);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}



const Tabs = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Tabs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    .MuiTabScrollButton-root {\n      &.Mui-disabled {\n        opacity: unset;\n        color: ".concat(theme.palette.text.disabled, ";\n      }\n\n      > .MuiSvgIcon-fontSizeSmall {\n        font-size: ").concat(theme.typography.h5.fontSize, ";\n      }\n    }\n\n    .MuiTabs-indicator {\n      height: 4px;\n    }\n  ");
});
const Tab = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    &.MuiTab-root {\n      min-width: unset;\n      padding: ".concat(theme.spacing(3), " ").concat(theme.spacing(4), ";\n      font-size: ").concat(theme.typography.h6.fontSize, ";\n      font-weight: initial;\n\n      &.Mui-selected {\n        font-weight: 700;\n      }\n\n      ").concat(theme.breakpoints.up("lg"), " {\n        padding: ").concat(theme.spacing(3), " ").concat(theme.spacing(6), ";\n      }\n    }\n  ");
});


/***/ }),

/***/ 58104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67836);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77366);
/* harmony import */ var _mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9041);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2982);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61953);
// 開發進度：已完成 Label 樣式的 Large，Medium 與 Small 則完成基本設定
// 屬性說明
// clearable：是否顯示清除按鈕

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}








// 依 size 取得輸入框整體&外框樣式
const getOutlinedAndInputStyles = (size, theme)=>{
    switch(size){
        case "large":
            return "\n        font-size: ".concat(theme.typography.bodyLarge.fontSize, ";\n        height: 56px;\n        padding: 16px;\n        gap: 8px;\n        svg {\n          width: 24px;\n          height: 24px;\n        }\n      ");
        case "medium":
            return "\n        font-size: ".concat(theme.typography.bodyMedium.fontSize, ";\n        height: 44px;\n        padding: 12px;\n        gap: 6px;\n        svg {\n          width: 20px;\n          height: 20px;\n        }\n      ");
        case "small":
            return "\n        font-size: ".concat(theme.typography.bodySmall.fontSize, ";\n        height: 37px;\n        padding: 10px;\n        gap: 4px;\n        svg {\n          width: 16px;\n          height: 16px;\n        }\n      ");
        default:
            return "";
    }
};
// 依 size 取得輸入框基本內容樣式
// height 算法為該元件高度扣除 padding，與 Figma 相符
const getInputBaseStyles = (size, theme, isStartAdornment)=>{
    switch(size){
        case "large":
            return "\n        font-size: ".concat(theme.typography.bodyLarge.fontSize, ";\n        height: 24px;\n        padding: 16px 16px 16px ").concat(isStartAdornment ? "0px" : "16px", ";\n        &::placeholder {\n          font-size: ").concat(theme.typography.bodyLarge.fontSize, ";\n          font-weight: ").concat(theme.typography.bodyLarge.fontWeight, ";\n        }\n      ");
        case "medium":
            return "\n        font-size: ".concat(theme.typography.bodyMedium.fontSize, ";\n        height: 20px;\n        padding: 12px 12px 12px ").concat(isStartAdornment ? "0px" : "12px", ";\n        &::placeholder {\n          font-size: ").concat(theme.typography.bodyMedium.fontSize, ";\n          font-weight: ").concat(theme.typography.bodyMedium.fontWeight, ";\n        }\n      ");
        case "small":
            return "\n        font-size: ".concat(theme.typography.bodySmall.fontSize, ";\n        height: 17px;\n        padding: 10px 10px 10px ").concat(isStartAdornment ? "0px" : "10px", ";\n        &::placeholder {\n          font-size: ").concat(theme.typography.bodySmall.fontSize, ";\n          font-weight: ").concat(theme.typography.bodySmall.fontWeight, ";\n        }\n      ");
        default:
            return "";
    }
};
// 依 size 取得標籤樣式
// 優化：目前手動調整 line-height 達成垂直置中，可優化
const getInputLabelStyles = (size, theme)=>{
    switch(size){
        case "large":
            return "\n        font-size: ".concat(theme.typography.bodyLarge.fontSize, ";\n        line-height: 22px;\n      ");
        case "medium":
            return "\n        font-size: ".concat(theme.typography.bodyMedium.fontSize, ";\n        line-height: 15px;\n      ");
        case "small":
            return "\n        font-size: ".concat(theme.typography.bodySmall.fontSize, ";\n        line-height: 19px;\n      ");
        default:
            return "";
    }
};
// 依 size 取得 helper text 樣式
const getHelperTextStyles = (size, theme)=>{
    switch(size){
        case "large":
            return "\n        font-size: ".concat(theme.typography.paraBodySmall.fontSize, ";\n        font-weight: ").concat(theme.typography.paraBodySmall.fontWeight, ";\n        line-height: ").concat(theme.typography.paraBodySmall.lineHeight, ";\n        letter-spacing: ").concat(theme.typography.paraBodySmall.letterSpacing, ";\n        margin: 4px 16px 0px;\n      ");
        case "medium":
        case "small":
            return "\n        font-size: ".concat(theme.typography.paraBodyXs.fontSize, ";\n        font-weight: ").concat(theme.typography.paraBodyXs.fontWeight, ";\n        line-height: ").concat(theme.typography.paraBodyXs.lineHeight, ";\n        letter-spacing: ").concat(theme.typography.paraBodyXs.letterSpacing, ";\n        margin: 2px 12px 0px;\n      ");
        default:
            return "";
    }
};
const StyledTextField = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , direction , size , error , isDisabledAndHasValue , isLabelTextGreen , isStartAdornment  } = param;
    return "\n    .MuiOutlinedInput-root,\n    .MuiInputBase-root {\n      ".concat(getOutlinedAndInputStyles(size, theme), "\n    }\n  \n    .MuiInputBase-input {\n      color: ").concat(theme.palette.primary.main, ";\n      text-align: ").concat(direction || "inherit", ";\n      ").concat(getInputBaseStyles(size, theme, isStartAdornment), "\n      &::placeholder {\n        opacity: 1;\n        color: ").concat(theme.palette.text.secondary, ";\n      }\n    }\n\n    .MuiInputLabel-root, fieldset {\n      ").concat(getInputLabelStyles(size, theme), "\n      border-color: ").concat(theme.palette.background.line, ";\n      color: ").concat(error ? theme.palette.error.main : isLabelTextGreen ? theme.palette.primary.main : theme.palette.text.secondary, "\n    }\n\n    .MuiFormHelperText-root {\n      ").concat(getHelperTextStyles(size, theme), "\n      color: ").concat(error ? theme.palette.error.main : theme.palette.text.secondary, "\n    }\n\n    // disabled 狀態下的樣式覆寫\n    .MuiOutlinedInput-root.Mui-disabled {\n      background-color: ").concat(isDisabledAndHasValue ? "inherit" : theme.palette.background.gray, ";\n      .MuiOutlinedInput-notchedOutline {\n        border-color: ").concat(isDisabledAndHasValue ? theme.palette.text.minus2 : theme.palette.background.line, ";\n      }\n    }\n    .MuiInputBase-input.Mui-disabled {\n      background-color: ").concat(isDisabledAndHasValue ? "inherit" : theme.palette.background.gray, ";\n      color: ").concat(isDisabledAndHasValue ? "inherit" : theme.palette.text.minus2, ";\n    }\n    .MuiInputLabel-root.Mui-disabled {\n      color: ").concat(isDisabledAndHasValue ? theme.palette.text.minus2 : theme.palette.text.disabled, ";\n    }\n    .MuiOutlinedInput-input.Mui-disabled {\n      -webkit-text-fill-color: ").concat(isDisabledAndHasValue ? theme.palette.text.minus2 : theme.palette.text.disabled, ";\n    }\n\n    #clear-svg {\n      width: 16px;\n      height: 16px;\n    }\n\n    // 自動填入時透過延遲背景色變化來防止瀏覽器預設淺藍底色出現\n    input:-webkit-autofill {\n      -webkit-box-shadow: 0 0 0 100px transparent inset;\n      -webkit-text-fill-color: ").concat(theme.palette.primary.main, ";\n      transition: background-color 5000s ease-in-out 0s;\n    }\n\n  ");
});
const TextFieldBasic = (props)=>{
    const { InputProps , onFocus , onBlur , onChange , setErrorState , value , clearable =false , disabled =false , error =false , size ="large" , ...rest } = props;
    const [isFocused, setIsFocused] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const isDisabledAndHasValue = disabled && value !== "";
    const isStartAdornment = !!lodash__WEBPACK_IMPORTED_MODULE_2___default().get(InputProps, "startAdornment");
    const isLabelTextGreen = !error && isFocused;
    const handleFocus = (e)=>{
        if (onFocus) onFocus(e);
        setIsFocused(true);
    };
    const handleBlur = (e)=>{
        if (onBlur) onBlur(e);
        setIsFocused(false);
    };
    const handleChange = (e)=>{
        if (onChange) onChange(e.target.value);
        if (setErrorState && error) {
            setErrorState(false);
        }
    };
    const handleClear = ()=>{
        if (onChange) {
            onChange("");
        }
    };
    // 將外部傳入的 InputProps 與清除按鈕做合併
    const mergedInputProps = {
        ...InputProps,
        // 若外部有設定 endAdornment 則亦保留原有元素
        endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                InputProps && InputProps.endAdornment,
                clearable && !disabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    position: "end",
                    children: value && isFocused ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        display: "flex",
                        alignItems: "center",
                        p: 1,
                        onClick: handleClear,
                        onMouseDown: (e)=>e.preventDefault(),
                        sx: {
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_8__/* .ClearSVG */ .A, {
                            id: "clear-svg"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        display: "flex",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            height: 24,
                            width: 24
                        })
                    })
                })
            ]
        })
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTextField, {
        ...rest,
        size: size,
        value: value,
        disabled: disabled,
        error: error,
        isFocused: isFocused,
        isDisabledAndHasValue: isDisabledAndHasValue,
        isStartAdornment: isStartAdornment,
        isLabelTextGreen: isLabelTextGreen,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onChange: handleChange,
        InputProps: mergedInputProps
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextFieldBasic);


/***/ }),

/***/ 44265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tabs/Tabs.js + 8 modules
var Tabs = __webpack_require__(62722);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(18661);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var styles_useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery_useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./utils/api/hooks/useArticleLayout.js
var useArticleLayout = __webpack_require__(36558);
// EXTERNAL MODULE: ./utils/api/hooks/useCatalogs.js
var useCatalogs = __webpack_require__(20796);
// EXTERNAL MODULE: ./utils/api/hooks/useCatalogsServiceMenus.js
var useCatalogsServiceMenus = __webpack_require__(7269);
// EXTERNAL MODULE: ./components/common/A/index.js
var A = __webpack_require__(79592);
// EXTERNAL MODULE: ./components/common/Layout/index.js
var Layout = __webpack_require__(82023);
// EXTERNAL MODULE: ./components/common/Header/index.js + 2 modules
var Header = __webpack_require__(75883);
// EXTERNAL MODULE: ./components/common/ContentWrapper/index.js
var ContentWrapper = __webpack_require__(55856);
// EXTERNAL MODULE: ./store/selfConstruct/selfConstructSlice.js
var selfConstructSlice = __webpack_require__(67030);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography_Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./components/common/BreakWordTypography/index.js
var BreakWordTypography = __webpack_require__(20667);
// EXTERNAL MODULE: ./utils/hooks/index.js
var hooks = __webpack_require__(13946);
;// CONCATENATED MODULE: ./components/pages/Index/ServiceLayout/ServiceCard.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}











const minHeightValue = "0px";
const AbsoluteTypography = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 10;\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    align-items: flex-end;\n    padding: 16px;\n\n    ".concat(theme.breakpoints.up("md"), " {\n      justify-content: center;\n      padding: 24px 16px;\n    }\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      &:hover {\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n  ");
});
const ServiceCardBox = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    position: relative;\n    cursor: pointer;\n    background-color: transparent;\n    border-radius: 12px;\n    overflow: hidden;\n    -webkit-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n\n\n    ".concat(theme.breakpoints.up("sm"), " {\n      border-radius: 24px;\n    }\n\n    ").concat(theme.breakpoints.up("md"), " {\n      width: 164px;\n      height: 164px;\n      padding-top: 0;\n    }\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      width: 140px;\n      height: 140px;\n\n      &:hover {\n        box-shadow: 0px 14px 12px rgba(0, 0, 0, 10%);\n      }\n    }\n\n    ").concat(theme.breakpoints.up("xl"), " {\n      width: 164px;\n      height: 164px;  \n    }\n\n    ").concat(theme.breakpoints.up("xxl"), " {\n      width: 218px;\n      height: 218px;\n    }\n  ");
});
const ImgMask = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    position: absolute;\n    top: 40%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 2;\n    border-radius: 12px;\n    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));\n\n    ".concat(theme.breakpoints.up("sm"), " {\n      border-radius: 24px;    \n    }\n  ");
});
const ImgHoverMask = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 2;\n    top: 10%;\n    border-radius: 12px;\n    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));\n\n    ".concat(theme.breakpoints.up("sm"), " {\n      border-radius: 24px;    \n    }\n  ");
});
const ServiceCardDEFAULT = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4(), (param)=>{
    let { theme  } = param;
    return "\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 2;\n    background-color: ".concat(theme.palette.primary.minus2, ";\n    border-radius: 12px;\n\n    ").concat(theme.breakpoints.up("sm"), " {\n      border-radius: 24px;\n    }\n  ");
});
const ServiceCardImg = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject5(), (param)=>{
    let { theme  } = param;
    return "\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: bottom;\n    border-radius: 12px;\n\n    ".concat(theme.breakpoints.up("sm"), " {\n      border-radius: 24px;\n    }\n  ");
});
const ImgRect = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(_templateObject6(), (param)=>{
    let { theme  } = param;
    return "\n    position: relative;\n    padding-top: 66.6%;\n\n    ".concat(theme.breakpoints.up("md"), " {\n      padding-top: 100%;\n    }\n  ");
});
const Absolute = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject7());
const ServiceCard_ServiceCard = (param)=>{
    let { catalogData , lazy , lazyOptions  } = param;
    var _catalogData_displayBelowBannerInfo, _catalogData_displayBelowBannerInfo_image, _catalogData_displayBelowBannerInfo1, _catalogData_displayBelowBannerInfo_mobileImage, _catalogData_displayBelowBannerInfo2;
    const [hovered, setHovered] = (0,react.useState)(false);
    const theme = (0,styles_useTheme/* default */.Z)();
    const isDesktop = (0,useMediaQuery_useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    const [ref, isImageLoaded, onLoadComplete] = (0,hooks/* useImageLoaded */.h3)();
    var _lazyOptions_offset;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
        height: minHeightValue,
        offset: (_lazyOptions_offset = lazyOptions === null || lazyOptions === void 0 ? void 0 : lazyOptions.offset) !== null && _lazyOptions_offset !== void 0 ? _lazyOptions_offset : 0,
        scrollContainer: (lazyOptions === null || lazyOptions === void 0 ? void 0 : lazyOptions.containerId) && "#".concat(lazyOptions.containerId),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardBox, {
            onMouseEnter: ()=>setHovered(true),
            onMouseLeave: ()=>setHovered(false),
            children: [
                !isImageLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceCardDEFAULT, {}) : isDesktop && hovered ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgHoverMask, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgMask, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                    href: catalogData.link ? catalogData.link : "",
                    $origin: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgRect, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Absolute, {
                            children: [
                                isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceCardImg, {
                                    ref: ref,
                                    onLoad: onLoadComplete,
                                    src: (_catalogData_displayBelowBannerInfo = catalogData.displayBelowBannerInfo) === null || _catalogData_displayBelowBannerInfo === void 0 ? void 0 : (_catalogData_displayBelowBannerInfo_image = _catalogData_displayBelowBannerInfo.image) === null || _catalogData_displayBelowBannerInfo_image === void 0 ? void 0 : _catalogData_displayBelowBannerInfo_image.url
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceCardImg, {
                                    ref: ref,
                                    onLoad: onLoadComplete,
                                    src: (_catalogData_displayBelowBannerInfo1 = catalogData.displayBelowBannerInfo) === null || _catalogData_displayBelowBannerInfo1 === void 0 ? void 0 : (_catalogData_displayBelowBannerInfo_mobileImage = _catalogData_displayBelowBannerInfo1.mobileImage) === null || _catalogData_displayBelowBannerInfo_mobileImage === void 0 ? void 0 : _catalogData_displayBelowBannerInfo_mobileImage.url
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AbsoluteTypography, {
                                    variant: "subtitle2",
                                    color: "primary.contrastText",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle2",
                                            color: "primary.contrastText",
                                            sx: {
                                                whiteSpace: "nowrap"
                                            },
                                            children: catalogData.name
                                        }),
                                        isDesktop && hovered && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakWordTypography/* default */.Z, {
                                            variant: {
                                                xs: "body2",
                                                xl: "label"
                                            },
                                            color: "primary.contrastText",
                                            sx: {
                                                textAlign: "center"
                                            },
                                            mt: 1,
                                            children: (_catalogData_displayBelowBannerInfo2 = catalogData.displayBelowBannerInfo) === null || _catalogData_displayBelowBannerInfo2 === void 0 ? void 0 : _catalogData_displayBelowBannerInfo2.description
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
ServiceCard_ServiceCard.defaultProps = {
    lazy: false,
    lazyOptions: {
        offset: 0,
        containerId: ""
    }
};
/* harmony default export */ var ServiceLayout_ServiceCard = ((/* unused pure expression or super */ null && (ServiceCard_ServiceCard)));

;// CONCATENATED MODULE: ./components/pages/Index/ServiceLayout/AllServiceCard.js

function AllServiceCard_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    AllServiceCard_templateObject = function() {
        return data;
    };
    return data;
}
function AllServiceCard_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0);\n  bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: center;\n"
    ]);
    AllServiceCard_templateObject1 = function() {
        return data;
    };
    return data;
}






const DEFAULT_ALLSERVICELOGO = "/img/all_service_icon.svg";
const AllServiceWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(AllServiceCard_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    position: relative;\n    width: 100%;\n    height: 96px;\n    cursor: pointer;\n    background-color: white;\n    border-radius: 12px;\n    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%), 0 2px 12px 0 rgb(0 0 0 / 5%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 16px;\n\n    &:active {\n      box-shadow: 0 0px 0px 0 transparent;\n      border: 1px solid ".concat(theme.palette.background.line, ";\n    }\n\n    ").concat(theme.breakpoints.up("sm"), " {\n      border-radius: 24px;   \n      margin-bottom: 24px;\n    }\n\n    ").concat(theme.breakpoints.up("md"), " {\n      width: 100%;\n      height: 112px;\n    }\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      width: 140px;\n      height: 140px;\n      margin-bottom: 0px;\n\n      &:hover {\n        box-shadow: 0 0px 0px 0 transparent;\n        border: 1px solid ").concat(theme.palette.background.line, ";\n      }\n    }\n\n    ").concat(theme.breakpoints.up("xl"), " {\n      width: 164px;\n      height: 164px;  \n    }\n\n    ").concat(theme.breakpoints.up("xxl"), " {\n      width: 218px;\n      height: 218px;\n    }\n  ");
});
const AbsoluteBox = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(AllServiceCard_templateObject1());
const AllServiceMobileCard = (param)=>{
    let { openAllServiceModal  } = param;
    return /*#__PURE__*/ _jsxs(AllServiceWrapper, {
        onClick: openAllServiceModal,
        children: [
            /*#__PURE__*/ _jsx("img", {
                width: 24,
                height: 24,
                src: DEFAULT_ALLSERVICELOGO
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle2",
                color: "textMinus2",
                ml: 4,
                sx: {
                    whiteSpace: "nowrap"
                },
                children: "全部服務"
            })
        ]
    });
};
const AllServiceDesktopCard = (param)=>{
    let { openAllServiceModal  } = param;
    return /*#__PURE__*/ _jsx(AllServiceWrapper, {
        onClick: openAllServiceModal,
        children: /*#__PURE__*/ _jsxs(AbsoluteBox, {
            children: [
                /*#__PURE__*/ _jsx("img", {
                    width: 48,
                    height: 48,
                    src: DEFAULT_ALLSERVICELOGO
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "subtitle2",
                    color: "textMinus2",
                    mt: {
                        xs: 4,
                        xl: 6,
                        xxl: 12
                    },
                    sx: {
                        whiteSpace: "nowrap"
                    },
                    children: "全部服務"
                })
            ]
        })
    });
};
const AllServiceCard_AllServiceCard = (param)=>{
    let { openAllServiceModal  } = param;
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: isDesktop ? /*#__PURE__*/ _jsx(AllServiceDesktopCard, {
            openAllServiceModal: openAllServiceModal
        }) : /*#__PURE__*/ _jsx(AllServiceMobileCard, {
            openAllServiceModal: openAllServiceModal
        })
    });
};
/* harmony default export */ var ServiceLayout_AllServiceCard = ((/* unused pure expression or super */ null && (AllServiceCard_AllServiceCard)));

;// CONCATENATED MODULE: ./components/pages/Index/ServiceLayout/index.js

function ServiceLayout_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ServiceLayout_templateObject = function() {
        return data;
    };
    return data;
}
function ServiceLayout_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ServiceLayout_templateObject1 = function() {
        return data;
    };
    return data;
}






const ServiceLayoutWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(ServiceLayout_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin: 24px auto;\n  justify-content: space-between;\n  padding-left: 16px;\n  padding-right: 16px;\n  min-height: 180px;\n  height: auto;\n\n    ".concat(theme.breakpoints.up("md"), " {\n      width: 704px;\n      maxwidth: 704px;\n      min-height: 276px;\n      padding-left: 0px;\n      padding-right: 0px;  \n      margin: 32px auto;\n    }\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      width: 770px;\n      maxwidth: 770px;\n      min-height: 140px;\n      flex-direction: row;\n      margin: 40px auto;\n    }\n\n    ").concat(theme.breakpoints.up("xl"), " {\n      min-height: 164px;\n      width: 916px;\n      maxwidth: 916px;    \n    }\n\n    ").concat(theme.breakpoints.up("xxl"), " {\n      min-height: 218px;\n      width: 1222px;\n      maxwidth: 1222px;\n    }\n  ");
});
const ServiceCardWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(ServiceLayout_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n  width: 100%;\n\n    ".concat(theme.breakpoints.up("lg"), " {\n      width: calc(100% - 156px);\n    }\n\n    ").concat(theme.breakpoints.up("xl"), " {\n      width: calc(100% - 188px);\n    }\n\n    ").concat(theme.breakpoints.up("xxl"), " {\n      width: calc(100% - 250px);\n    }\n  ");
});
const ServiceLayout = (param)=>{
    let { openAllServiceModal , containerId , catalogsData  } = param;
    return /*#__PURE__*/ _jsxs(ServiceLayoutWrapper, {
        children: [
            /*#__PURE__*/ _jsx(AllServiceCard, {
                openAllServiceModal: openAllServiceModal
            }),
            /*#__PURE__*/ _jsx(ServiceCardWrapper, {
                children: /*#__PURE__*/ _jsx(Grid, {
                    container: true,
                    rowSpacing: {
                        xs: 2,
                        md: 4,
                        xl: 6,
                        xxl: 8
                    },
                    columnSpacing: {
                        xs: 2,
                        md: 4,
                        xl: 6,
                        xxl: 8
                    },
                    children: catalogsData === null || catalogsData === void 0 ? void 0 : catalogsData.map((catalog)=>{
                        return /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 6,
                            md: "auto",
                            children: /*#__PURE__*/ _jsx(ServiceCard, {
                                catalogData: catalog,
                                lazy: true,
                                lazyOptions: {
                                    containerId
                                }
                            })
                        }, catalog._id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Index_ServiceLayout = ((/* unused pure expression or super */ null && (ServiceLayout)));

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(20724);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(13379);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(21082);
// EXTERNAL MODULE: ./components/common/Banner/DesktopPaginationWithTitle.js
var DesktopPaginationWithTitle = __webpack_require__(44395);
// EXTERNAL MODULE: ./components/common/Banner/BannerWrapper.js
var BannerWrapper = __webpack_require__(11666);
// EXTERNAL MODULE: ./components/common/Banner/StyledSwiper.js
var StyledSwiper = __webpack_require__(98121);
// EXTERNAL MODULE: ./components/common/Banner/index.js
var Banner = __webpack_require__(25820);
// EXTERNAL MODULE: ./utils/api/hooks/useBanners.js
var useBanners = __webpack_require__(13929);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/sendBannerClick.js
var sendBannerClick = __webpack_require__(24994);
// EXTERNAL MODULE: ./utils/api/general/genPathByNavData.js
var genPathByNavData = __webpack_require__(39086);
// EXTERNAL MODULE: ./store/webview/webviewSlice.js
var webviewSlice = __webpack_require__(86377);
// EXTERNAL MODULE: ./utils/hooks/useBannerGA.js + 1 modules
var useBannerGA = __webpack_require__(778);
;// CONCATENATED MODULE: ./components/pages/Index/BannerCarousel/index.js





















const modules = [
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Autoplay */.pt,
    swiper_esm/* Lazy */.oM
];
const BannerCarousel_Banner = (param)=>{
    let { banner , router , isMobile , isFirst , onBannerClick  } = param;
    var _banner_image;
    if (isMobile) {
        var _banner_imageDouble, _banner_imageDouble1;
        return isFirst ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* BannerImg */.tS, {
            src: banner === null || banner === void 0 ? void 0 : (_banner_imageDouble = banner.imageDouble) === null || _banner_imageDouble === void 0 ? void 0 : _banner_imageDouble.url,
            onClick: onBannerClick
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* BannerImg */.tS, {
            "data-src": banner === null || banner === void 0 ? void 0 : (_banner_imageDouble1 = banner.imageDouble) === null || _banner_imageDouble1 === void 0 ? void 0 : _banner_imageDouble1.url,
            onClick: onBannerClick,
            className: "swiper-lazy"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* BannerImg */.tS, {
        src: banner === null || banner === void 0 ? void 0 : (_banner_image = banner.image) === null || _banner_image === void 0 ? void 0 : _banner_image.url,
        onClick: onBannerClick
    });
};
const swiperSettings = {
    spaceBetween: 24,
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    pagination: {
        el: ".banner-pagination",
        clickable: true
    },
    slideToClickedSlide: true
};
const swiperAutoplay = {
    delay: 5000,
    disableOnInteraction: false
};
const BannerCarousel = (param)=>{
    let { fallbackData , isMobile  } = param;
    var _banners_, _banners_1, _banners_2;
    const webview = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    const [swiper, setSwiper] = (0,react.useState)(null);
    const [swiperIndex, setSwiperIndex] = (0,react.useState)(0);
    const [hovered, setHovered] = (0,react.useState)(false);
    const onNextClick = ()=>{
        return swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
    };
    const onPrevClick = ()=>{
        return swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
    };
    const theme = (0,styles_useTheme/* default */.Z)();
    const isDesktop = (0,useMediaQuery_useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    const { data  } = (0,useBanners/* useBanners */.U)(webview === null || webview === void 0 ? void 0 : webview.name, null, fallbackData ? {
        fallbackData
    } : undefined);
    const banners = fallbackData || data;
    const router = (0,next_router.useRouter)();
    const onBannerClick = (banner)=>async ()=>{
            (0,sendBannerClick/* sendBannerClick */.y)({
                banner,
                bannerLocation: "首頁"
            });
            const { path , isExternalLink  } = await (0,genPathByNavData/* genPathByNavData */.E)(banner.navData);
            if (path) {
                if (isExternalLink) {
                    window.open(path, "_blank");
                } else {
                    router.push(path);
                }
            }
        };
    (0,useBannerGA/* useBannerGAForCarousel */.a)({
        bannerData: banners,
        bannerLocation: "首頁",
        swiper,
        isRepeated: false
    });
    (0,useBannerGA/* useBannerGAForCarousel */.a)({
        bannerData: banners,
        bannerLocation: "首頁",
        swiper,
        isRepeated: true
    });
    const onIndexChange = (swiper)=>{
        if (swiper.realIndex > -1) {
            setSwiperIndex(swiper.realIndex);
        }
    };
    // 設0時會有bug(無法顯示左圖)，當0時index設定為length但跳轉第二張圖有反向行為，因此設定指定位址為下一個loop的index
    const onPaginationIndexClick = (index)=>{
        return swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(banners.length + index);
    };
    if (!(banners === null || banners === void 0 ? void 0 : banners.length)) {
        return null;
    }
    const swiperNavigation = {
        nextEl: ".instance-".concat((_banners_ = banners[0]) === null || _banners_ === void 0 ? void 0 : _banners_._id, " .banner-swiper-next"),
        prevEl: ".instance-".concat((_banners_1 = banners[0]) === null || _banners_1 === void 0 ? void 0 : _banners_1._id, " .banner-swiper-prev")
    };
    // 防止 banner 在 mobile 輪播時圖片還沒載入完成
    const swiperLazyOptions = isMobile ? {
        loadOnTransitionStart: true,
        loadPrevNext: true
    } : false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerWrapper/* default */.Z, {
        mb: isDesktop ? 10 : 6,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            onMouseEnter: ()=>setHovered(true),
            onMouseLeave: ()=>setHovered(false),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwiper/* StyledSwiper */.W, {
                modules: modules,
                ...swiperSettings,
                preloadImages: !isMobile,
                lazy: swiperLazyOptions,
                watchSlidesProgress: isMobile,
                loopedSlides: banners.length,
                navigation: banners.length > 1 ? swiperNavigation : false,
                autoplay: banners.length > 1 ? swiperAutoplay : false,
                onAfterInit: (swiper)=>setSwiper(swiper),
                onRealIndexChange: onIndexChange,
                children: [
                    banners.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            hovered && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                className: "instance-".concat((_banners_2 = banners[0]) === null || _banners_2 === void 0 ? void 0 : _banners_2._id),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "banner-swiper-next",
                                        onClick: onNextClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "banner-swiper-prev",
                                        onClick: onPrevClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "banner-pagination"
                            })
                        ]
                    }),
                    banners === null || banners === void 0 ? void 0 : banners.map((banner, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerCarousel_Banner, {
                                banner: banner,
                                router: router,
                                isMobile: isMobile,
                                isFirst: index === 0,
                                onBannerClick: onBannerClick(banner)
                            })
                        }, banner._id)),
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopPaginationWithTitle/* default */.Z, {
                        data: banners,
                        currentIndex: swiperIndex,
                        onPaginationIndexClick: onPaginationIndexClick
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Index_BannerCarousel = (BannerCarousel);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(9041);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js + 2 modules
var styled = __webpack_require__(67074);
// EXTERNAL MODULE: ./components/common/SVGElements/Search.js
var Search = __webpack_require__(66212);
// EXTERNAL MODULE: ./components/common/TextFieldBasic/index.js
var TextFieldBasic = __webpack_require__(58104);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(73221);
// EXTERNAL MODULE: ./utils/hooks/fetchers.js
var fetchers = __webpack_require__(86700);
;// CONCATENATED MODULE: ./utils/api/hooks/useHomePageSearchBarTitle.js

// search bar title 不需重複抓，故增加 revalidate 設定
const useHomePageSearchBarTitle = (props)=>{
    var _data_;
    const { data , ...rest } = (0,fetchers/* useCustomSWR */.LW)("/systemSettings/specificKey?key=homePageSearchBarTitle", {
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    return {
        data: data === null || data === void 0 ? void 0 : (_data_ = data[0]) === null || _data_ === void 0 ? void 0 : _data_.value,
        ...rest
    };
};

// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/GtmAgent.js
var GtmAgent = __webpack_require__(27582);
;// CONCATENATED MODULE: ./components/pages/Index/SearchBarSection.js










const SearchBarSectionWrapper = (0,styled/* default */.ZP)(Box_Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        position: "relative",
        padding: "48px 0",
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.up("lg")]: {
            padding: "72px 0"
        }
    };
});
const SearchBarSection_ContentWrapper = (0,styled/* default */.ZP)(Box_Box/* default */.Z)({
    margin: "0 auto",
    width: "100%",
    maxWidth: "1200px",
    zIndex: 1
});
const TextWrapper = (0,styled/* default */.ZP)(Box_Box/* default */.Z)({
    maxWidth: "768px"
});
const ImageWrapper = (0,styled/* default */.ZP)(Box_Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        position: "absolute",
        right: 0,
        top: 0,
        width: "40%",
        maxWidth: "640px",
        height: "320px",
        zIndex: 0,
        "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "40%",
            height: "100%",
            background: "linear-gradient(to right, white 40%, transparent 100%)"
        },
        "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "30%",
            background: "linear-gradient(to top, white 20%, transparent 100%)"
        },
        [theme.breakpoints.down("lg")]: {
            display: "none"
        }
    };
});
const StyledImage = (0,styled/* default */.ZP)("img")({
    width: "100%",
    height: "100%",
    objectFit: "cover"
});
const SearchBarSection = ()=>{
    const [keyword, setKeyword] = (0,react.useState)("");
    const router = (0,next_router.useRouter)();
    const theme = (0,styles_useTheme/* default */.Z)();
    const isMobile = (0,useMediaQuery_useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const { data: homePageSearchBarTitle , isLoading: isHomePageSearchBarTitleLoading  } = useHomePageSearchBarTitle();
    const handleSearch = (e)=>{
        if (e.key === "Enter" && keyword.trim()) {
            const searchUrl = "".concat(constants/* LS_APP_DOMAIN */._8, "/vender/search?keyword=").concat(encodeURIComponent(keyword.trim()));
            GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                event: "living_action",
                living_event_name: "search_send",
                living_search_type: "廠商",
                living_search_keyword: "".concat(keyword.trim()),
                living_search_location: "首頁"
            });
            router.push(searchUrl);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarSectionWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBarSection_ContentWrapper, {
                px: {
                    xs: 4,
                    md: 8,
                    xl: 12
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: isMobile ? "headlineMedium" : "headlineLarge",
                            mb: 6,
                            children: isHomePageSearchBarTitleLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "rounded",
                                width: "70%",
                                height: "36px"
                            }) : homePageSearchBarTitle || "讓居家幫你輕鬆過日子"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextFieldBasic/* default */.Z, {
                            fullWidth: true,
                            size: "medium",
                            placeholder: "搜尋服務廠商",
                            value: keyword,
                            onChange: setKeyword,
                            onKeyPress: handleSearch,
                            InputProps: {
                                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* SearchSVG */.M, {
                                        color: theme.palette.text.secondary
                                    })
                                })
                            },
                            sx: {
                                "& .MuiInputBase-input": {
                                    backgroundColor: "transparent"
                                }
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    src: "/img/img_search_bar_section_bg.webp",
                    alt: "Search bar background img"
                })
            })
        ]
    });
};
/* harmony default export */ var Index_SearchBarSection = (SearchBarSection);

// EXTERNAL MODULE: ./components/common/NowrapDiv/index.js
var common_NowrapDiv = __webpack_require__(2925);
;// CONCATENATED MODULE: ./components/pages/Index/PopularServiceLayout/index.js

function PopularServiceLayout_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    PopularServiceLayout_templateObject = function() {
        return data;
    };
    return data;
}
function PopularServiceLayout_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    PopularServiceLayout_templateObject1 = function() {
        return data;
    };
    return data;
}
function PopularServiceLayout_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    PopularServiceLayout_templateObject2 = function() {
        return data;
    };
    return data;
}
function PopularServiceLayout_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    PopularServiceLayout_templateObject3 = function() {
        return data;
    };
    return data;
}
function PopularServiceLayout_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    PopularServiceLayout_templateObject4 = function() {
        return data;
    };
    return data;
}
function PopularServiceLayout_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 48px;\n  height: 48px;\n  object-fit: cover;\n"
    ]);
    PopularServiceLayout_templateObject5 = function() {
        return data;
    };
    return data;
}
function PopularServiceLayout_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    PopularServiceLayout_templateObject6 = function() {
        return data;
    };
    return data;
}










const DEFAULT_SERVICELOGO = "/img/default_service_icon.svg";
const PopularServiceLayout_ContentWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(PopularServiceLayout_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    width: 100%;\n    background-color: ".concat(theme.palette.background.gray, ";\n    padding: 24px 16px 48px 16px;\n    margin-bottom: 48px;\n\n    ").concat(theme.breakpoints.up("md"), " {\n      padding-left: 0px;\n      padding-right: 0px;\n      margin-bottom: 72px;\n    }\n  ");
});
const PopularServiceLayoutWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(PopularServiceLayout_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  justify-content: space-between;\n\n    ".concat(theme.breakpoints.up("md"), " {\n      width: 704px;\n      maxwidth: 704px;\n    }\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      width: 770px;\n      maxwidth: 770px;\n    }\n\n    ").concat(theme.breakpoints.up("xl"), " {\n      width: 916px;\n      maxwidth: 916px;\n    }\n\n    ").concat(theme.breakpoints.up("xxl"), " {\n      width: 1222px;\n      maxwidth: 1222px;\n    }\n  ");
});
const PopularServiceCardSection = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(PopularServiceLayout_templateObject2());
const PopularServiceCardContent = (0,emotion_styled_browser_esm/* default */.Z)(A/* default */.Z)(PopularServiceLayout_templateObject3(), (param)=>{
    let { theme , $isMargin  } = param;
    return "\n    width: 20%;\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: center;\n    margin-bottom: ".concat($isMargin ? "24px" : "0", ";\n\n    ").concat(theme.breakpoints.up("md"), " {\n      width: 10%;\n    }\n  ");
});
const ServiceCardImageWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(PopularServiceLayout_templateObject4(), (param)=>{
    let { $hovered  } = param;
    return "\n    position: relative;\n    margin-bottom: 12px;\n    transform: ".concat($hovered ? "translate(0, -8px)" : "translate(0, 0)", ";\n    transition: all 0.2s ease-in-out;\n  ");
});
const PopularServiceCardImage = emotion_styled_browser_esm/* default.img */.Z.img(PopularServiceLayout_templateObject5());
const HoverCardPoint = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(PopularServiceLayout_templateObject6(), (param)=>{
    let { theme , $hovered  } = param;
    return "\n    height: 4px;\n    width: 4px;\n    border-radius: 50%;\n    background-color: ".concat($hovered ? theme.palette.primary.main : "transparent", ";\n    position: absolute;\n    left: 50%;\n    bottom: -8px;\n    transform: translate(-50%, 0);\n  ");
});
const PopularServiceCard = (param)=>{
    let { classificationItem , isMargin  } = param;
    var _classificationItem_entranceIcon;
    const [hovered, setHovered] = useState(false);
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
    return /*#__PURE__*/ _jsxs(PopularServiceCardContent, {
        $isMargin: isMargin,
        href: "/service/".concat(classificationItem === null || classificationItem === void 0 ? void 0 : classificationItem.identityCode),
        $origin: true,
        onMouseEnter: ()=>isDesktop && setHovered(true),
        onMouseLeave: ()=>isDesktop && setHovered(false),
        children: [
            /*#__PURE__*/ _jsxs(ServiceCardImageWrapper, {
                $hovered: hovered,
                children: [
                    /*#__PURE__*/ _jsx(PopularServiceCardImage, {
                        src: (classificationItem === null || classificationItem === void 0 ? void 0 : (_classificationItem_entranceIcon = classificationItem.entranceIcon) === null || _classificationItem_entranceIcon === void 0 ? void 0 : _classificationItem_entranceIcon.url) || DEFAULT_SERVICELOGO
                    }),
                    /*#__PURE__*/ _jsx(HoverCardPoint, {
                        $hovered: hovered
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "label",
                color: "textMinus2",
                children: /*#__PURE__*/ _jsx(NowrapDiv, {
                    $lines: 2,
                    $textCenter: true,
                    children: (classificationItem === null || classificationItem === void 0 ? void 0 : classificationItem.name) || ""
                })
            })
        ]
    });
};
const PopularServiceLayout = ()=>{
    var _classifications_slice, _classifications_slice1, _classifications_slice2;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { data: classifications  } = useServiceClassifications({
        displayVisible: "visible",
        filterByServicesExists: true
    });
    return /*#__PURE__*/ _jsx(PopularServiceLayout_ContentWrapper, {
        children: /*#__PURE__*/ _jsxs(PopularServiceLayoutWrapper, {
            children: [
                /*#__PURE__*/ _jsx(Box, {
                    width: "100%",
                    borderBottom: "1px solid #D4D4D4",
                    mb: 6,
                    children: /*#__PURE__*/ _jsx(Typography, {
                        mb: 4,
                        variant: "label",
                        color: "textMinus2",
                        fontWeight: "bold",
                        sx: {
                            whiteSpace: "nowrap"
                        },
                        children: "熱門服務"
                    })
                }),
                isMobile ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(PopularServiceCardSection, {
                            children: (_classifications_slice = classifications === null || classifications === void 0 ? void 0 : classifications.slice(0, 4)) === null || _classifications_slice === void 0 ? void 0 : _classifications_slice.map((item, index)=>{
                                return /*#__PURE__*/ _jsx(PopularServiceCard, {
                                    classificationItem: item,
                                    isMargin: true
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ _jsx(PopularServiceCardSection, {
                            children: (_classifications_slice1 = classifications === null || classifications === void 0 ? void 0 : classifications.slice(4, 8)) === null || _classifications_slice1 === void 0 ? void 0 : _classifications_slice1.map((item, index)=>{
                                return /*#__PURE__*/ _jsx(PopularServiceCard, {
                                    classificationItem: item
                                }, index);
                            })
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(PopularServiceCardSection, {
                    children: (_classifications_slice2 = classifications === null || classifications === void 0 ? void 0 : classifications.slice(0, 8)) === null || _classifications_slice2 === void 0 ? void 0 : _classifications_slice2.map((item, index)=>{
                        return /*#__PURE__*/ _jsx(PopularServiceCard, {
                            classificationItem: item
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Index_PopularServiceLayout = ((/* unused pure expression or super */ null && (PopularServiceLayout)));

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./components/common/Modal/index.js
var Modal = __webpack_require__(37524);
// EXTERNAL MODULE: ./components/common/AllServiceModal/Tabs.js
var AllServiceModal_Tabs = __webpack_require__(71273);
// EXTERNAL MODULE: ./components/common/AllServiceModal/ModalComponent.js
var ModalComponent = __webpack_require__(76457);
;// CONCATENATED MODULE: ./components/common/ShowAllServiceModal/index.js

function ShowAllServiceModal_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ShowAllServiceModal_templateObject = function() {
        return data;
    };
    return data;
}
function ShowAllServiceModal_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ShowAllServiceModal_templateObject1 = function() {
        return data;
    };
    return data;
}















const ShowAllServiceModal_DEFAULT_SERVICELOGO = "/img/default_service_icon.svg";
const a11yProps = (index)=>{
    return {
        id: "scrollable-tab-".concat(index),
        "aria-controls": "scrollable-tab-panel-".concat(index)
    };
};
const IconButtonWrapper = (0,emotion_styled_browser_esm/* default */.Z)(IconButton/* default */.Z)(ShowAllServiceModal_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n  > .MuiSvgIcon-root {\n    fill: ".concat(theme.palette.text.minus2, ";\n    font-size: 24px;\n  }\n");
});
const ShowAllServiceModal_HoverCardPoint = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(ShowAllServiceModal_templateObject1(), (param)=>{
    let { theme , $hovered  } = param;
    return "\n    height: 4px;\n    width: 4px;\n    border-radius: 50%;\n    background-color: ".concat($hovered ? theme.palette.primary.main : "transparent", ";\n    position: absolute;\n    left: 50%;\n    bottom: -8px;\n    transform: translate(-50%, 0);\n  ");
});
// 服務方案區塊
const ServiceClassificationCard = (param)=>{
    let { item  } = param;
    var _item_serviceClassification, _item_serviceClassification1, _item_serviceClassification_entranceIcon, _item_serviceClassification2;
    const theme = (0,styles_useTheme/* default */.Z)();
    const isDesktop = (0,useMediaQuery_useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    const [hovered, setHovered] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        gridColumn: {
            xs: "span 3",
            md: "span 2"
        },
        sx: {
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
            $origin: true,
            href: "/service/".concat((_item_serviceClassification = item.serviceClassification) === null || _item_serviceClassification === void 0 ? void 0 : _item_serviceClassification.identityCode),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalComponent/* ServiceIconWrapper */.xt, {
                onMouseEnter: ()=>isDesktop && setHovered(true),
                onMouseLeave: ()=>isDesktop && setHovered(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalComponent/* LogoImageWrapper */.gr, {
                        $hovered: hovered,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (item === null || item === void 0 ? void 0 : (_item_serviceClassification1 = item.serviceClassification) === null || _item_serviceClassification1 === void 0 ? void 0 : (_item_serviceClassification_entranceIcon = _item_serviceClassification1.entranceIcon) === null || _item_serviceClassification_entranceIcon === void 0 ? void 0 : _item_serviceClassification_entranceIcon.url) || ShowAllServiceModal_DEFAULT_SERVICELOGO,
                                width: "48px",
                                height: "48px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowAllServiceModal_HoverCardPoint, {
                                $hovered: hovered
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NowrapDiv/* default */.Z, {
                        $lines: 2,
                        $textCenter: true,
                        children: item === null || item === void 0 ? void 0 : (_item_serviceClassification2 = item.serviceClassification) === null || _item_serviceClassification2 === void 0 ? void 0 : _item_serviceClassification2.name
                    })
                ]
            })
        })
    });
};
// 子目錄區塊
const ServiceClassificationList = (param)=>{
    let { subCatalog , isShowSubTitle , name , isFirst  } = param;
    var _subCatalog_items;
    const showCatalogItem = subCatalog === null || subCatalog === void 0 ? void 0 : (_subCatalog_items = subCatalog.items) === null || _subCatalog_items === void 0 ? void 0 : _subCatalog_items.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.type) === "serviceClassification";
    });
    if ((showCatalogItem === null || showCatalogItem === void 0 ? void 0 : showCatalogItem.length) <= 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalComponent/* ServiceClassificationWrapper */.N3, {
        $isFirst: isFirst,
        children: [
            isShowSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakWordTypography/* default */.Z, {
                mb: 4,
                variant: "label",
                color: "textSecondary",
                fontWeight: "fontWeightBold",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                display: "grid",
                gridTemplateColumns: "repeat(12, 1fr)",
                gap: 4,
                children: subCatalog === null || subCatalog === void 0 ? void 0 : subCatalog.map((item)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceClassificationCard, {
                        item: item
                    }, item._id);
                })
            })
        ]
    });
};
const ShowAllServiceModal = (param)=>{
    let { open , onClose , catalogsData  } = param;
    const [tabIndex, setTabIndex] = (0,react.useState)(0);
    const [catalogItems, setCatalogItems] = (0,react.useState)([]);
    const [showCatalogItems, setShowCatalogItems] = (0,react.useState)([]);
    const [subCatalogName, setSubCatalogName] = (0,react.useState)([]);
    const onTabChange = (e, newTabIndex)=>{
        setTabIndex(newTabIndex);
    };
    (0,react.useEffect)(()=>{
        const getCatalogData = async ()=>{
            setCatalogItems(catalogsData.map((catalogData)=>{
                return catalogData === null || catalogData === void 0 ? void 0 : catalogData.subcatalogs;
            }));
        };
        if (catalogsData === null || catalogsData === void 0 ? void 0 : catalogsData.length) getCatalogData();
    }, [
        catalogsData
    ]);
    (0,react.useEffect)(()=>{
        const setShowItems = async ()=>{
            var _catalogItems_tabIndex;
            const subCatalogs = (catalogItems === null || catalogItems === void 0 ? void 0 : (_catalogItems_tabIndex = catalogItems[tabIndex]) === null || _catalogItems_tabIndex === void 0 ? void 0 : _catalogItems_tabIndex.sort((a, b)=>b.sort - a.sort)) || [];
            subCatalogs === null || subCatalogs === void 0 ? void 0 : subCatalogs.forEach((subCatalog)=>{
                var _subCatalog_items;
                const serviceItem = (_subCatalog_items = subCatalog.items) === null || _subCatalog_items === void 0 ? void 0 : _subCatalog_items.filter((item)=>{
                    return item.type === "serviceClassification";
                });
                if ((serviceItem === null || serviceItem === void 0 ? void 0 : serviceItem.length) > 0) {
                    setSubCatalogName((subCatalogName)=>{
                        return [
                            ...subCatalogName,
                            subCatalog === null || subCatalog === void 0 ? void 0 : subCatalog.name
                        ];
                    });
                    setShowCatalogItems((showCatalogItems)=>[
                            ...showCatalogItems,
                            serviceItem
                        ]);
                }
            });
        };
        if (catalogsData === null || catalogsData === void 0 ? void 0 : catalogsData.length) setShowItems();
        return ()=>{
            setShowCatalogItems([]);
            setSubCatalogName([]);
        };
    }, [
        catalogItems,
        tabIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* FunctionModal */.rK, {
        open: open,
        onClose: onClose,
        ModalWrapper: ModalComponent/* Wrapper */.im,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalComponent/* StickyWrapper */.iW, {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                color: "textMinus2",
                                children: "選擇預約服務"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButtonWrapper, {
                                onClick: onClose,
                                size: "large",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                            })
                        ]
                    }),
                    (catalogsData === null || catalogsData === void 0 ? void 0 : catalogsData.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(AllServiceModal_Tabs/* TabsWrapper */.tS, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AllServiceModal_Tabs/* Tabs */.mQ, {
                            value: tabIndex,
                            onChange: onTabChange,
                            scrollButtons: true,
                            "aria-label": "image tabs",
                            children: catalogsData === null || catalogsData === void 0 ? void 0 : catalogsData.map((catalog, index)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(AllServiceModal_Tabs/* Tab */.OK, {
                                    label: catalog === null || catalog === void 0 ? void 0 : catalog.name,
                                    ...a11yProps(index)
                                }, index);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalComponent/* ScrollableWrapper */.__, {
                children: showCatalogItems === null || showCatalogItems === void 0 ? void 0 : showCatalogItems.map((item, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceClassificationList, {
                        name: subCatalogName[index],
                        subCatalog: item,
                        isShowSubTitle: (showCatalogItems === null || showCatalogItems === void 0 ? void 0 : showCatalogItems.length) > 1,
                        isFirst: index < 1
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var common_ShowAllServiceModal = (ShowAllServiceModal);

// EXTERNAL MODULE: ./components/common/ScrollableWrapper/index.js
var ScrollableWrapper = __webpack_require__(28086);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/lodash-es/sortBy.js
var sortBy = __webpack_require__(98697);
// EXTERNAL MODULE: ./components/common/SVGElements/ArrowRight.js
var ArrowRight = __webpack_require__(69854);
;// CONCATENATED MODULE: ./components/pages/Index/ServiceMenusCard.js

function ServiceMenusCard_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ServiceMenusCard_templateObject = function() {
        return data;
    };
    return data;
}
function ServiceMenusCard_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ServiceMenusCard_templateObject1 = function() {
        return data;
    };
    return data;
}













const ServiceMenusCard_DEFAULT_SERVICELOGO = "/img/default_service_icon.svg";
const StyledCard = (0,styled/* default */.ZP)(Card/* default */.Z)(ServiceMenusCard_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    position: relative;\n    padding: 12px;\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    border: 1px solid ".concat(theme.palette.grey.secondary, ";\n    border-radius: 6px;\n    background: ").concat(theme.palette.white.main, ";\n    cursor: pointer;\n    &:hover,&:active {\n      background: ").concat(theme.palette.primary.bgPlus2, ";\n    }\n  ");
});
const ServiceMenusCard_IconButtonWrapper = (0,styled/* default */.ZP)(IconButton/* default */.Z)(ServiceMenusCard_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n  padding: 0;\n    > svg {\n      fill: ".concat(theme.palette.text.secondary, ";\n      width: 16px;\n      height: 16px;\n    }\n  ");
});
const ServiceMenusCard_ServiceCard = (param)=>/*#__PURE__*/ {
    let { title , content , link , onClick , ...cardProps } = param;
    return (0,jsx_runtime.jsxs)(StyledCard, {
        elevation: 0,
        onClick: ()=>onClick && onClick({
                title,
                content,
                link,
                ...cardProps
            }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                flex: 1,
                minWidth: 0,
                gap: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "labelLarge",
                        color: "text.minus2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NowrapDiv/* default */.Z, {
                            $lines: 2,
                            children: title
                        })
                    }),
                    content && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "paraBodyXs",
                        color: "text.secondary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NowrapDiv/* default */.Z, {
                            $lines: 2,
                            children: content
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceMenusCard_IconButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {
                    width: "16",
                    height: "16"
                })
            })
        ]
    });
};
const ServiceCardGrid = (param)=>{
    let { cards , onCardClick , tab , onSubMenusLinkClick  } = param;
    const theme = (0,styles_useTheme/* default */.Z)();
    const isSmall = (0,useMediaQuery_useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const router = (0,next_router.useRouter)();
    const handleCardClick = (card)=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "servicemenu_click",
            living_click_name: card === null || card === void 0 ? void 0 : card.title,
            ...(card === null || card === void 0 ? void 0 : card._id) && {
                living_click_id: card._id
            },
            living_category1_name: tab === null || tab === void 0 ? void 0 : tab.label,
            living_category1_id: tab === null || tab === void 0 ? void 0 : tab._id
        });
        if (onCardClick) {
            onCardClick(card.link);
            return;
        }
        if (!card.link) return;
        if (card.type === "serviceClassification") {
            router.push("/vender?serviceItem=".concat(card === null || card === void 0 ? void 0 : card._id));
            return;
        }
        if (card.linkTarget === "blank") {
            window.open(card.link, "_blank");
        } else {
            router.push(card.link);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        display: "grid",
        gridTemplateColumns: isSmall ? "repeat(2, 1fr)" : "repeat(5, 1fr)",
        gap: isSmall ? 2 : 4,
        mb: isSmall ? 12 : 18,
        children: [
            (tab === null || tab === void 0 ? void 0 : tab.link) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                gridColumn: isSmall ? "1 / -1" : "span 2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
                    elevation: 0,
                    onClick: onSubMenusLinkClick,
                    sx: {
                        alignItems: "center",
                        height: "100%",
                        border: "1px solid ".concat(theme.palette.primary.minus2),
                        gap: 3,
                        "&:hover, &:active": {
                            border: "1px solid ".concat(theme.palette.primary.main)
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            display: "flex",
                            alignItems: "center",
                            flex: 1,
                            minWidth: 0,
                            gap: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: 44,
                                    height: 44,
                                    flexShrink: 0,
                                    borderRadius: 1,
                                    sx: {
                                        backgroundColor: "grey.third",
                                        ".MuiCard-root:hover &, .MuiCard-root:active &": {
                                            backgroundColor: "background.default"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        component: "img",
                                        src: (tab === null || tab === void 0 ? void 0 : tab.imageUrl) || ServiceMenusCard_DEFAULT_SERVICELOGO,
                                        width: 24,
                                        height: 24,
                                        sx: {
                                            filter: "brightness(0) saturate(100%) invert(35%) sepia(2%) saturate(3%) hue-rotate(22deg) brightness(92%) contrast(85%)"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "titleLarge",
                                    color: "text.minus2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NowrapDiv/* default */.Z, {
                                        $lines: 2,
                                        children: (tab === null || tab === void 0 ? void 0 : tab.linkDisplayName) || "前往".concat(tab === null || tab === void 0 ? void 0 : tab.label)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceMenusCard_IconButtonWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {
                                width: "16",
                                height: "16"
                            })
                        })
                    ]
                })
            }),
            cards.map((card, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceMenusCard_ServiceCard, {
                    ...card,
                    onClick: handleCardClick
                }, idx))
        ]
    });
};
function ServiceMenusCard(param) {
    let { subcatalogs , onCardClick , tab , onSubMenusLinkClick  } = param;
    const theme = (0,styles_useTheme/* default */.Z)();
    const isSmall = (0,useMediaQuery_useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    if (!subcatalogs || !Array.isArray(subcatalogs)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceCardGrid, {
            cards: [],
            onCardClick: onCardClick,
            tab: tab
        });
    }
    const allCards = subcatalogs.flatMap((subcat)=>{
        var _subcat_items;
        return ((_subcat_items = subcat.items) === null || _subcat_items === void 0 ? void 0 : _subcat_items.map((item)=>{
            if (item.type === "serviceClassification" && item.serviceClassification) {
                return {
                    title: item.serviceClassification.name || "",
                    content: item.serviceClassification.briefly || "",
                    link: "/service/".concat(item.serviceClassification.identityCode),
                    type: "serviceClassification",
                    _id: item.serviceClassification._id,
                    createdAt: item.serviceClassification.createdAt,
                    venderCountByServiceItem: item.serviceClassification.venderCountByServiceItem || 0
                };
            } else if (item.type === "link") {
                return {
                    title: item.name || "",
                    content: item.description || "",
                    link: item.link || "",
                    linkTarget: item.linkTarget || "self",
                    type: "link",
                    sort: subcat.sort || 0
                };
            }
            return null;
        }).filter(Boolean)) || [];
    });
    // 去除重複的 serviceClassification（根據 _id）
    const uniqueCards = allCards.filter((card, index, array)=>{
        if (card.type !== "serviceClassification") {
            return true;
        }
        // 對於 serviceClassification，只保留第一次出現的 _id
        return array.findIndex((c)=>c.type === "serviceClassification" && c._id === card._id) === index;
    });
    const sortedCards = (0,sortBy/* default */.Z)(uniqueCards, [
        // 首先按類型排序：serviceClassification 在前，link 在後
        (card)=>card.type === "serviceClassification" ? 0 : 1,
        // 按 sort 排序（數字大的在前）
        (card)=>card.type === "link" ? -card.sort : 0,
        // 按 venderCountByServiceItem 排序（數字大的在前）
        (card)=>card.type === "serviceClassification" ? -card.venderCountByServiceItem : 0,
        // 按 createdAt 排序（新到舊）
        (card)=>card.type === "serviceClassification" ? -new Date(card.createdAt || 0).getTime() : 0
    ]);
    const hasTabLinkCard = tab === null || tab === void 0 ? void 0 : tab.link;
    const maxItems = isSmall ? hasTabLinkCard ? 8 : 10 : hasTabLinkCard ? 18 : 20;
    const cards = sortedCards.slice(0, maxItems);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceCardGrid, {
        cards: cards,
        onCardClick: onCardClick,
        tab: tab,
        onSubMenusLinkClick: onSubMenusLinkClick
    });
}

;// CONCATENATED MODULE: ./components/pages/Index/ServiceMenusTabs.js











const ServiceMenusTabs_DEFAULT_SERVICELOGO = "/img/default_service_icon.svg";
const StyledTabs = (0,emotion_styled_browser_esm/* default */.Z)(Tabs/* default */.Z)((param)=>{
    let { theme , isDownMd , isDownLg , isMobile  } = param;
    return {
        position: "relative",
        paddingTop: isDownMd ? 16 : 24,
        paddingBottom: isDownMd ? 16 : 24,
        "& .MuiTab-root": {
            textTransform: "none",
            padding: isDownMd ? "2px 0px 8px 0px" : "2px 4px 8px 4px",
            marginRight: isDownMd ? "2vw" : isDownLg ? "12px" : "24px",
            justifyContent: "flex-start",
            width: isDownMd ? "15vw" : "auto",
            minHeight: 0,
            minWidth: 0,
            "&:last-child": {
                marginRight: 0
            }
        },
        "& .MuiTabs-indicator": {
            display: "flex",
            justifyContent: "center",
            backgroundColor: "transparent",
            height: 4,
            "&::after": {
                content: '""',
                display: "block",
                width: 32,
                height: 4,
                borderRadius: 2,
                backgroundColor: theme.palette.primary.main
            }
        },
        "& .MuiTabs-scrollButtons": {
            position: "absolute",
            top: 0,
            bottom: 0,
            zIndex: 10,
            width: 40,
            "&:first-of-type": {
                left: 0,
                background: "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.9) 25%, rgba(255,255,255,0.5) 70%, rgba(255,255,255,0) 100%)"
            },
            "&:last-of-type": {
                right: 0,
                background: "linear-gradient(270deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.9) 25%, rgba(255,255,255,0.5) 70%, rgba(255,255,255,0) 100%)"
            }
        },
        "& .MuiTabs-scroller": {
            overflow: isMobile ? "auto" : "hidden",
            position: "relative"
        }
    };
});
// https://angel-rs.github.io/css-color-filter-generator/ hex 轉 filter 網站
// isSelected ? '#75AA00' : '#5A5A5A'
const TabIcon = emotion_styled_browser_esm/* default.img */.Z.img((param)=>{
    let { isSelected  } = param;
    return {
        width: 24,
        height: 24,
        filter: isSelected ? "brightness(0) saturate(100%) invert(62%) sepia(38%) saturate(3133%) hue-rotate(40deg) brightness(90%) contrast(101%)" : "brightness(0) saturate(100%) invert(35%) sepia(2%) saturate(3%) hue-rotate(22deg) brightness(92%) contrast(85%)"
    };
});
const StyledTab = (0,emotion_styled_browser_esm/* default */.Z)(Tab/* default */.Z)((param)=>{
    let { theme , isSelected  } = param;
    return {
        ...isSelected ? theme.typography.labelMedium : theme.typography.bodyXs
    };
});
function TabPanel(param) {
    let { value , index , subcatalogs , tab , onSubMenusLinkClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "tabpanel",
        hidden: value !== index,
        id: "icon-tabpanel-".concat(index),
        children: value === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceMenusCard, {
            subcatalogs: subcatalogs,
            tab: tab,
            onSubMenusLinkClick: onSubMenusLinkClick
        })
    });
}
function ServiceMenusTabs(param) {
    let { catalogsServiceMenus , onTabChange , onSubMenusLinkClick , isMobile  } = param;
    const [value, setValue] = (0,react.useState)(0);
    const theme = (0,styles_useTheme/* default */.Z)();
    const isDownLg = (0,useMediaQuery_useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const isDownMd = (0,useMediaQuery_useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    const tabData = (0,sortBy/* default */.Z)((catalogsServiceMenus === null || catalogsServiceMenus === void 0 ? void 0 : catalogsServiceMenus.flatMap((catalog)=>{
        var _catalog_subMenus;
        return ((_catalog_subMenus = catalog.subMenus) === null || _catalog_subMenus === void 0 ? void 0 : _catalog_subMenus.map((subMenu)=>{
            var _subMenu_defaultCategoryImage;
            return {
                label: subMenu.name,
                linkDisplayName: subMenu.linkDisplayName,
                imageUrl: (_subMenu_defaultCategoryImage = subMenu.defaultCategoryImage) === null || _subMenu_defaultCategoryImage === void 0 ? void 0 : _subMenu_defaultCategoryImage.url,
                subcatalogs: subMenu.subcatalogs || [],
                link: subMenu.link || "",
                linkTarget: subMenu.linkTarget || "self",
                sort: subMenu.sort || 0,
                createdAt: subMenu.createdAt,
                _id: subMenu === null || subMenu === void 0 ? void 0 : subMenu._id
            };
        })) || [];
    })) || [], [
        (item)=>-(item.sort || 0),
        // createdAt 排序（新到舊）
        // 如果 createdAt 不存在，則視為最舊
        (item)=>item.createdAt ? -new Date(item.createdAt).getTime() : 0
    ]);
    const handleChange = (event, newValue)=>{
        setValue(newValue);
        onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(tabData[newValue], true);
    };
    (0,react.useEffect)(()=>{
        if (tabData.length > 0 && onTabChange) {
            onTabChange(tabData[0]);
        }
    }, []);
    const createTabIcon = (imageUrl, isSelected)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TabIcon, {
            src: imageUrl || ServiceMenusTabs_DEFAULT_SERVICELOGO,
            isSelected: isSelected
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        mb: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTabs, {
                value: value,
                onChange: handleChange,
                variant: "scrollable",
                scrollButtons: isMobile ? false : "auto",
                allowScrollButtonsMobile: true,
                isDownMd: isDownMd,
                isDownLg: isDownLg,
                isMobile: isMobile,
                children: tabData.map((tab, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, {
                        icon: createTabIcon(tab.imageUrl, value === idx),
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NowrapDiv/* default */.Z, {
                            $lines: 2,
                            $textCenter: true,
                            children: tab.label
                        }),
                        isSelected: value === idx
                    }, "".concat(tab.label, "-").concat(idx)))
            }),
            tabData.map((tab, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                    value: value,
                    index: idx,
                    subcatalogs: tab.subcatalogs,
                    tab: tab,
                    onSubMenusLinkClick: onSubMenusLinkClick
                }, "".concat(tab.label, "-").concat(idx)))
        ]
    });
}

// EXTERNAL MODULE: ./config/theme.js + 1 modules
var theme = __webpack_require__(26059);
;// CONCATENATED MODULE: ./components/pages/Index/HomeServiceMenus.js





const HomeServiceMenus = (param)=>{
    let { catalogsServiceMenus , isSmall , isMobile , handleTabChange , handleSubMenusLinkClick  } = param;
    var _catalogsServiceMenus_, _catalogsServiceMenus_1;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        maxWidth: theme/* indexPageMaxContentWidth */.LN,
        margin: "0 auto",
        mb: 4,
        px: {
            xs: 4,
            md: 8,
            xl: 12
        },
        children: [
            (catalogsServiceMenus === null || catalogsServiceMenus === void 0 ? void 0 : (_catalogsServiceMenus_ = catalogsServiceMenus[0]) === null || _catalogsServiceMenus_ === void 0 ? void 0 : _catalogsServiceMenus_.homeServiceMenuTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                color: "text.minus1",
                variant: isSmall ? "titleLarge" : "headlineMedium",
                children: (_catalogsServiceMenus_1 = catalogsServiceMenus[0]) === null || _catalogsServiceMenus_1 === void 0 ? void 0 : _catalogsServiceMenus_1.homeServiceMenuTitle
            }),
            catalogsServiceMenus && catalogsServiceMenus.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceMenusTabs, {
                catalogsServiceMenus: catalogsServiceMenus,
                onTabChange: handleTabChange,
                onSubMenusLinkClick: handleSubMenusLinkClick,
                isMobile: isMobile
            })
        ]
    });
};
/* harmony default export */ var Index_HomeServiceMenus = (HomeServiceMenus);

// EXTERNAL MODULE: ./components/common/Present/index.js
var Present = __webpack_require__(99469);
// EXTERNAL MODULE: ./utils/api/general/getLayoutModuleById.js
var getLayoutModuleById = __webpack_require__(6636);
;// CONCATENATED MODULE: ./components/pages/Index/PopularServices.js







const PopularServices = (param)=>{
    let { catalogsServiceMenus  } = param;
    var _catalogsServiceMenus_flatMap;
    if (!(catalogsServiceMenus === null || catalogsServiceMenus === void 0 ? void 0 : catalogsServiceMenus.length)) {
        return null;
    }
    const handleClick = (item)=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "popular_click",
            living_click_id: item._id,
            living_click_name: item.label
        });
    };
    // 處理資料並排序
    const serviceItems = (_catalogsServiceMenus_flatMap = catalogsServiceMenus === null || catalogsServiceMenus === void 0 ? void 0 : catalogsServiceMenus.flatMap((menu)=>{
        var _menu_subMenus;
        return ((_menu_subMenus = menu.subMenus) === null || _menu_subMenus === void 0 ? void 0 : _menu_subMenus.flatMap((submenu)=>{
            var _submenu_subcatalogs;
            return ((_submenu_subcatalogs = submenu.subcatalogs) === null || _submenu_subcatalogs === void 0 ? void 0 : _submenu_subcatalogs.flatMap((subcatalog)=>{
                var _subcatalog_items;
                return (_subcatalog_items = subcatalog.items) === null || _subcatalog_items === void 0 ? void 0 : _subcatalog_items.filter((item)=>{
                    var _item_serviceClassification;
                    return item.type === "serviceClassification" && ((_item_serviceClassification = item.serviceClassification) === null || _item_serviceClassification === void 0 ? void 0 : _item_serviceClassification.isVisible) === true;
                }).map((item)=>({
                        label: item.serviceClassification.name,
                        href: "/vender?page=1&serviceItem=".concat(item.serviceClassification._id),
                        venderCountByServiceItem: item.serviceClassification.venderCountByServiceItem || 0,
                        createdAt: new Date(item.serviceClassification.createdAt || 0).getTime(),
                        _id: item.serviceClassification._id,
                        submenuSort: submenu.sort || 0,
                        submenuCreatedAt: submenu.createdAt ? new Date(submenu.createdAt).getTime() : 0
                    }));
            })) || [];
        })) || [];
    })) === null || _catalogsServiceMenus_flatMap === void 0 ? void 0 : _catalogsServiceMenus_flatMap.filter((item, index, self)=>index === self.findIndex((i)=>i._id === item._id))// 排序邏輯：submenuSort -> submenuCreatedAt -> venderCountByServiceItem -> createdAt
    .sort((a, b)=>{
        if (a.submenuSort !== b.submenuSort) {
            return b.submenuSort - a.submenuSort;
        }
        if (a.submenuCreatedAt !== b.submenuCreatedAt) {
            return b.submenuCreatedAt - a.submenuCreatedAt;
        }
        if (a.venderCountByServiceItem !== b.venderCountByServiceItem) {
            return b.venderCountByServiceItem - a.venderCountByServiceItem;
        }
        return b.createdAt - a.createdAt;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        maxWidth: theme/* indexPageMaxContentWidth */.LN,
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: {
            xs: 4,
            lg: 6
        },
        pb: 18,
        px: {
            xs: 4,
            md: 8,
            xl: 12
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "headlineMedium",
                children: "熱門服務"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "16px 0",
                children: serviceItems.map((item, index, array)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                href: item.href,
                                onClick: ()=>handleClick(item),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "bodySmall",
                                    color: "text.minus2",
                                    children: item.label
                                })
                            }),
                            index < array.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                component: "span",
                                mx: 3,
                                height: "17px",
                                width: "1px",
                                backgroundColor: "#EBEBEB"
                            })
                        ]
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var Index_PopularServices = (PopularServices);

// EXTERNAL MODULE: ./components/common/Footer/index.js + 12 modules
var Footer = __webpack_require__(56007);
;// CONCATENATED MODULE: ./components/pages/Index/index.js

function Index_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .MuiTabs-indicator {\n    height: 5px;\n  }\n\n  .MuiTab-textColorInherit {\n    opacity: 1;\n  }\n"
    ]);
    Index_templateObject = function() {
        return data;
    };
    return data;
}
function Index_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 30px 0;\n\n  ",
        "\n"
    ]);
    Index_templateObject1 = function() {
        return data;
    };
    return data;
}
function Index_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Index_templateObject2 = function() {
        return data;
    };
    return data;
}
function Index_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Index_templateObject3 = function() {
        return data;
    };
    return data;
}

































const DynamicSyDomesticServiceList = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6679).then(__webpack_require__.bind(__webpack_require__, 36679)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(36679)
            ]
    },
    ssr: false
});
const DynamicArticleLayoutSwiper = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4029).then(__webpack_require__.bind(__webpack_require__, 54029)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(54029)
            ]
    },
    ssr: false
});
const emptySx = {};
const ClassificationTabs = (0,emotion_styled_browser_esm/* default */.Z)(Tabs/* default */.Z)(Index_templateObject());
const CustomTab = (0,emotion_styled_browser_esm/* default */.Z)(Tab/* default */.Z)(Index_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      padding: 15px 30px;\n    }\n  ");
});
const TabButton = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(Index_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    ".concat(theme.breakpoints.up("lg"), " {\n      flex-direction: row;\n\n      &:hover {\n        background-color: ").concat(theme.palette.primary.bgPlus1, ";\n      }\n    }\n  ");
});
const TabHouseCleaning = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef((props, ref)=>{
    const selected = props["aria-selected"];
    const [hovered, setHovered] = useState(false);
    return /*#__PURE__*/ _jsxs(TabButton, {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        ...props,
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        ref: ref,
        sx: emptySx,
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: selected || hovered ? "/img/btn_menu_clean_selected.svg" : "/img/btn_menu_clean_inactive.svg",
                width: "64",
                height: "46"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: "textPrimary",
                fontWeight: selected ? "fontWeightBold" : "fontWeightRegular",
                children: "清潔消毒"
            })
        ]
    });
})));
const TabEmpty1 = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef((props, ref)=>{
    const selected = props["aria-selected"];
    const [hovered, setHovered] = useState(false);
    return /*#__PURE__*/ _jsxs(TabButton, {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        ...props,
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        ref: ref,
        sx: emptySx,
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: selected || hovered ? "/img/btn_menu_appliance_cleaning_selected.svg" : "/img/btn_menu_appliance_cleaning_inactive.svg",
                width: "64",
                height: "46"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: "textPrimary",
                fontWeight: selected ? "fontWeightBold" : "fontWeightRegular",
                children: "家電清潔"
            })
        ]
    });
})));
const TabEmpty2 = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef((props, ref)=>{
    const selected = props["aria-selected"];
    const [hovered, setHovered] = useState(false);
    return /*#__PURE__*/ _jsxs(TabButton, {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        ...props,
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        ref: ref,
        sx: emptySx,
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: selected || hovered ? "/img/btn_menu_wrench_selected.svg" : "/img/btn_menu_wrench_inactive.svg",
                width: "64",
                height: "46"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: "textPrimary",
                fontWeight: selected ? "fontWeightBold" : "fontWeightRegular",
                children: "裝潢修繕"
            })
        ]
    });
})));
const TabRelocation = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef((props, ref)=>{
    const selected = props["aria-selected"];
    const [hovered, setHovered] = useState(false);
    return /*#__PURE__*/ _jsxs(TabButton, {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        ...props,
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        ref: ref,
        sx: emptySx,
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: selected || hovered ? "/img/btn_menu_movehouse_selected.svg" : "/img/btn_menu_movehouse_inactive.svg",
                width: "64",
                height: "46"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: "textPrimary",
                fontWeight: selected ? "fontWeightBold" : "fontWeightRegular",
                children: "搬家回收"
            })
        ]
    });
})));
const PanelWrapper = (0,emotion_styled_browser_esm/* default */.Z)(ContentWrapper/* default */.Z)(Index_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      width: calc(100% - 76px);\n      border: 1px solid ").concat(theme.palette.background.gray, ";\n      box-shadow: 0px 0px 8px #F4F4F4, 0px 2px 4px #FBFBFB;\n    }\n\n    ").concat(theme.breakpoints.up("xl"), " {\n      width: calc(100% - 96px);\n    }\n\n    ").concat(theme.breakpoints.up("xxl"), " {\n      width: calc(100% - 128px);\n    }\n  ");
});
const Index_TabPanel = (param)=>{
    let { index , value , children , ...rest } = param;
    if (index !== value) {
        return null;
    }
    return /*#__PURE__*/ _jsx(PanelWrapper, {
        py: {
            xs: 10,
            lg: 12.5
        },
        px: {
            xs: 4,
            lg: 24
        },
        sx: emptySx,
        children: children
    });
};
const Index = (param)=>{
    let { isMobile , fallbackData  } = param;
    var _layout_homepages;
    const theme = (0,styles_useTheme/* default */.Z)();
    const isSmall = (0,useMediaQuery_useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    const [tabIndex, setTabIndex] = (0,react.useState)(0);
    const onTabChange = (event, newTab)=>setTabIndex(newTab);
    const selfConstruct = (0,es/* useSelector */.v9)(selfConstructSlice/* selectSelfConstruct */.k$);
    const [layoutModules, setLayoutModules] = (0,react.useState)([]);
    const { homePageLayout  } = fallbackData;
    const scrollableRef = (0,react.useRef)(null);
    const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
    const [selectedTab, setSelectedTab] = (0,react.useState)(null);
    const { data: catalogsServiceMenus  } = (0,useCatalogsServiceMenus/* useCatalogsServiceMenus */.J)({
        target: "mainHomeServiceMenu"
    });
    const router = (0,next_router.useRouter)();
    const handleTabChange = (tabData, isUserTriggered)=>{
        setSelectedTab(tabData);
        // 只有使用者想切換而點擊時才送GA
        if (isUserTriggered) {
            GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                event: "living_action",
                living_event_name: "servicemenu_click",
                living_click_name: tabData === null || tabData === void 0 ? void 0 : tabData.label,
                living_click_id: tabData === null || tabData === void 0 ? void 0 : tabData._id
            });
        }
    };
    const handleSubMenusLinkClick = ()=>{
        if (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.link) {
            if ((selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.linkTarget) === "blank") {
                window.open(selectedTab.link, "blank");
            } else {
                router.push(selectedTab.link);
            }
        }
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "servicemenu_click",
            living_click_name: (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.linkDisplayName) || "前往".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.label),
            living_category1_name: selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.label,
            living_category1_id: selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab._id
        });
    };
    (0,react.useEffect)(()=>{
        var _location_href_split;
        const hash = (_location_href_split = location.href.split("#")) === null || _location_href_split === void 0 ? void 0 : _location_href_split[1];
        const hashIndexMap = {
            cleaning: 0,
            electricEquipClean: 1,
            moving: 2,
            homedeco: 3
        };
        // do nothing if hash index is 0, cause it's already is 0
        if (hashIndexMap[hash]) {
            setTabIndex(hashIndexMap[hash]);
        }
    }, []);
    (0,react.useEffect)(()=>{
        var _homePageLayout_modules;
        const getLayoutModules = async ()=>{
            const modules = homePageLayout === null || homePageLayout === void 0 ? void 0 : homePageLayout.modules;
            const results = await Promise.all(modules.map((id)=>(0,getLayoutModuleById/* getLayoutModuleById */.x)(id)));
            setLayoutModules(results.map((param)=>{
                let [data, error] = param;
                return error ? null : data;
            }));
        };
        if (homePageLayout === null || homePageLayout === void 0 ? void 0 : (_homePageLayout_modules = homePageLayout.modules) === null || _homePageLayout_modules === void 0 ? void 0 : _homePageLayout_modules.length) getLayoutModules();
    }, [
        homePageLayout === null || homePageLayout === void 0 ? void 0 : homePageLayout.modules
    ]);
    const [tabsVariant] = (0,react.useState)(isMobile ? "fullWidth" : "standard");
    const { data: layout  } = (0,useArticleLayout/* useArticleLayout */.o)("homepages", (fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.articleLayout) ? {
        fallbackData: [
            fallbackData.articleLayout
        ]
    } : undefined);
    const { data: catalogsBelowBanner  } = (0,useCatalogs/* useCatalogs */.$)({
        isDisplayBelowBannerInfo: true,
        isSelfBookingSource: false,
        isGetBelongsSubCatalogs: true,
        isVisible: true
    });
    const containerId = "homepage-scrollable";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        stickyHeader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
        mx: {
            xs: 0,
            lg: 16
        },
        fixContentHeight: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ShowAllServiceModal, {
                open: isModalOpen,
                onClose: ()=>setIsModalOpen(false),
                catalogsData: catalogsBelowBanner
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollableWrapper/* default */.Z, {
                wrapperRef: scrollableRef,
                containerId: containerId,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_SearchBarSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_BannerCarousel, {
                        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.banners,
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_HomeServiceMenus, {
                        catalogsServiceMenus: catalogsServiceMenus,
                        isSmall: isSmall,
                        isMobile: isMobile,
                        handleTabChange: handleTabChange,
                        handleSubMenusLinkClick: handleSubMenusLinkClick
                    }),
                    layoutModules === null || layoutModules === void 0 ? void 0 : layoutModules.map((module, index)=>{
                        return !(module === null || module === void 0 ? void 0 : module.isVisible) ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            mb: (module === null || module === void 0 ? void 0 : module.type) === "graphicMore" || (module === null || module === void 0 ? void 0 : module.type) === "publicitySmall" || (module === null || module === void 0 ? void 0 : module.type) === "banner" ? {
                                xs: 12,
                                md: 18
                            } : {
                                xs: 18,
                                md: 24
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Present/* default */.Z, {
                                data: module,
                                lazy: true,
                                lazyOptions: {
                                    containerId
                                }
                            }, module === null || module === void 0 ? void 0 : module._id)
                        }, index);
                    }),
                    layout === null || layout === void 0 ? void 0 : (_layout_homepages = layout.homepages) === null || _layout_homepages === void 0 ? void 0 : _layout_homepages.map((articleLayout, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                            height: 480,
                            offset: 50,
                            scrollContainer: "#".concat(containerId),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                minHeight: 345,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicArticleLayoutSwiper, {
                                    data: articleLayout
                                })
                            })
                        }, "layout-".concat(index))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_PopularServices, {
                        catalogsServiceMenus: catalogsServiceMenus
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        minHeight: 436,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_Index = (Index);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/pages/Index/MetaTags.js


/* harmony default export */ var MetaTags = ((param)=>{
    let { banner , isMobile  } = param;
    var _banner_imageDouble, _banner_image;
    return !!banner ? /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: !!banner && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
            rel: "preload",
            href: isMobile ? (_banner_imageDouble = banner.imageDouble) === null || _banner_imageDouble === void 0 ? void 0 : _banner_imageDouble.url : (_banner_image = banner.image) === null || _banner_image === void 0 ? void 0 : _banner_image.url,
            as: "image"
        })
    }) : null;
});

// EXTERNAL MODULE: ./utils/withLivingSinyi.js + 8 modules
var withLivingSinyi = __webpack_require__(93756);
// EXTERNAL MODULE: ./components/common/NoindexRemoval/index.js
var NoindexRemoval = __webpack_require__(84070);
;// CONCATENATED MODULE: ./pages/index.js





const IndexPage = (props)=>{
    var _props_fallbackData, _props_fallbackData_banners;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoindexRemoval/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags, {
                banner: (_props_fallbackData = props.fallbackData) === null || _props_fallbackData === void 0 ? void 0 : (_props_fallbackData_banners = _props_fallbackData.banners) === null || _props_fallbackData_banners === void 0 ? void 0 : _props_fallbackData_banners[0],
                isMobile: props.isMobile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_Index, {
                ...props
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = ((0,withLivingSinyi/* default */.Z)(IndexPage));


/***/ }),

/***/ 6636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ getLayoutModuleById; }
/* harmony export */ });
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72673);

const getLayoutModuleById = (moduleId)=>{
    return (0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .safeAwait */ .Ev)((0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .lsGet */ .UY)("/layoutModules/".concat(moduleId)));
};


/***/ }),

/***/ 36558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useArticleLayout; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72673);



const useArticleLayout = (type, swrOptions)=>{
    const { data , ...rest } = (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)("/articleLayouts?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)({
        type
    })), utils_request__WEBPACK_IMPORTED_MODULE_2__/* .lsGet */ .UY, swrOptions);
    return {
        data: data === null || data === void 0 ? void 0 : data[0],
        ...rest
    };
};


/***/ }),

/***/ 13929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useBanners; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72673);



const useBanners = function(webviewName) {
    let displayOpt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, swrOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const defaultSwrOptions = {
        revalidateOnFocus: false
    } // 由於 banner 加入隨機排序設定，所以不在 focus 時重新抓取，以免影響使用者體驗
    ;
    const visibleSource = !webviewName ? "lsWeb" : webviewName;
    const genUrl = ()=>{
        const getBannersUrl = "/banners/client?";
        let getBannersUrlQueryData = {
            visibleSource,
            displayAt: "homepage"
        };
        if (displayOpt) getBannersUrlQueryData = {
            ...getBannersUrlQueryData,
            ...displayOpt
        };
        return "".concat(getBannersUrl).concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(getBannersUrlQueryData));
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, utils_request__WEBPACK_IMPORTED_MODULE_2__/* .lsGet */ .UY, {
        ...defaultSwrOptions,
        ...swrOptions
    });
};


/***/ }),

/***/ 20796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useCatalogs; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72673);



const useCatalogs = function() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        limit: 999
    };
    const genUrl = ()=>utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .ZP.getToken() ? [
            "/catalogs?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(props)),
            utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .ZP.getToken()
        ] : "/catalogs?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(props));
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, utils_request__WEBPACK_IMPORTED_MODULE_2__/* .lsGetWithToken */ .n8);
};


/***/ }),

/***/ 13946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xh": function() { return /* binding */ useAlbumModal; },
/* harmony export */   "_S": function() { return /* binding */ usePreselectVenderManagement; },
/* harmony export */   "cB": function() { return /* binding */ useGetYearForFooter; },
/* harmony export */   "h3": function() { return /* binding */ useImageLoaded; },
/* harmony export */   "hq": function() { return /* binding */ useConfirmModalHandler; },
/* harmony export */   "o4": function() { return /* binding */ useDateTypeText; },
/* harmony export */   "zi": function() { return /* binding */ useShowScrollToTopButton; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89289);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79697);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39705);
/* harmony import */ var store_cache_cacheSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24363);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61225);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62097);








const useDateTypeText = (services, serviceIds)=>{
    const [dateTypeText, setDateTypeText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("施作");
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!(0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(services)) {
            const selectedNonStandardService = services.some((service)=>(serviceIds || []).includes(service._id) && !service.isStandard);
            setDateTypeText(selectedNonStandardService ? "估價" : "施作");
        }
    }, [
        services,
        serviceIds
    ]);
    return dateTypeText;
};
const confirmModelInit = {
    open: false,
    onPositiveClick: ()=>{},
    onNegativeClick: ()=>{},
    positiveButtonText: null,
    negativeButtonText: null,
    title: "",
    message: ""
};
const useConfirmModalHandler = ()=>{
    const [confirmModelConfig, setConfirmModelConfig] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(confirmModelInit);
    const close = ()=>{
        setConfirmModelConfig({
            ...confirmModelInit
        });
    };
    const open = (config)=>{
        setConfirmModelConfig({
            ...confirmModelInit,
            onNegativeClick: close,
            open: true,
            ...config
        });
    };
    return [
        confirmModelConfig,
        open,
        close
    ];
};
const useAlbumModal = (pathname, router, options)=>{
    const { webview , nativeHeaderHandler  } = options;
    const [albumModal, setAlbumModal] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        open: false
    });
    const closeAlbumModal = ()=>setAlbumModal({
            open: false
        });
    const onAlbumClick = (e, album)=>{
        var _album_urlId, _album_urlId_toLowerCase, _window_location_href_split;
        e.stopPropagation();
        e.preventDefault();
        if (!album) {
            throw new Error("useAlbumModal: album is undefined");
        }
        const albumUrlId = (_album_urlId_toLowerCase = (_album_urlId = album.urlId).toLowerCase) === null || _album_urlId_toLowerCase === void 0 ? void 0 : _album_urlId_toLowerCase.call(_album_urlId);
        const state = {
            ...window.history.state,
            url: "/album/".concat(albumUrlId),
            as: "/album/".concat(albumUrlId),
            idx: window.history.state.idx + 1
        };
        const photo = (album === null || album === void 0 ? void 0 : album.representativePhoto) || (album === null || album === void 0 ? void 0 : album.frontCover);
        const photoUrlId = photo === null || photo === void 0 ? void 0 : photo.urlId;
        const qs = ((_window_location_href_split = window.location.href.split("?")) === null || _window_location_href_split === void 0 ? void 0 : _window_location_href_split[1]) || "";
        const newQs = qs.split("&").filter((string)=>string && !/^(utm_|page=|tag=)/.test(string)).concat([
            "photoId=".concat(photoUrlId)
        ]).join("&");
        window.history.pushState(state, "", "/album/".concat(albumUrlId, "?").concat(newQs));
        router.query.albumUrlId = albumUrlId;
        router.query.photoId = photoUrlId;
        setAlbumModal({
            open: true,
            fallbackData: {
                photoUrlId: photoUrlId
            }
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const handlePopState = ()=>{
            if (location.pathname === pathname && albumModal.open) {
                setAlbumModal({
                    open: false
                });
                if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp" && nativeHeaderHandler) {
                    nativeHeaderHandler();
                }
            }
        };
        window.addEventListener("popstate", handlePopState);
        return ()=>{
            window.removeEventListener("popstate", handlePopState);
        };
    }, [
        albumModal
    ]);
    const onAlbumContentClose = ()=>{
        router.back();
        closeAlbumModal();
        if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp" && nativeHeaderHandler) {
            nativeHeaderHandler();
        }
    };
    return {
        albumModal,
        closeAlbumModal,
        onAlbumClick,
        onAlbumContentClose
    };
};
const usePreselectVenderManagement = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const [nextRoute, setNextRoute] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    // 當跳轉到非下訂流程時，移除preselectVender
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const onRouteChangeStart = (url, param)=>{
            let { shallow  } = param;
            if (shallow) {
                return;
            }
            const qs = url.split("?")[1] || "";
            const hasPreselectVender = qs.split("&").some((str)=>/^preselect_vender=/.test(str));
            if (!hasPreselectVender) {
                return;
            }
            if (!/^(\/service\/|\/login)/.test(url)) {
                const newQs = qs.split("&").filter((str)=>!/^preselect_vender=/.test(str)).join("&");
                dispatch((0,store_cache_cacheSlice__WEBPACK_IMPORTED_MODULE_3__/* .clearPreselectVender */ .mT)());
                setNextRoute(url.split("?")[0] + (newQs ? "?" + newQs : ""));
                router.events.emit("routeChangeError");
                throw "route change aborted";
            }
        };
        if (nextRoute) {
            router.push(nextRoute);
        }
        router.events.on("routeChangeStart", onRouteChangeStart);
        return ()=>{
            router.events.off("routeChangeStart", onRouteChangeStart);
        };
    }, [
        nextRoute
    ]);
};
const useGetYearForFooter = ()=>{
    const [currentYear, setCurrentYear] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setCurrentYear((0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Date(), "yyyy"));
    }, []);
    return currentYear;
};
const useShowScrollToTopButton = ()=>{
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    const [showButton, setShowButton] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const isMobile = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(theme.breakpoints.down("md"));
    const showScrollButton = (e)=>{
        if (isMobile) {
            e.currentTarget.scrollTop > 768 ? setShowButton(true) : setShowButton(false);
        } else {
            e.currentTarget.scrollTop > 800 ? setShowButton(true) : setShowButton(false);
        }
    };
    return {
        showButton,
        showScrollButton
    };
};
const useImageLoaded = ()=>{
    const [isImageLoaded, setIsImageLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const onLoadComplete = ()=>{
        setIsImageLoaded(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (ref.current && ref.current.complete) onLoadComplete();
    }, []);
    return [
        ref,
        isImageLoaded,
        onLoadComplete
    ];
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,3829,5897,9072,9477,231,5616,9705,6541,988,6760,3997,5795,1383,9531,3756,6245,6007,8121,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);